<template>
  <div>
    <div class="headerCom">
      <div class="text"><span>运营管理 / </span><span>落地页配置</span></div>
      <div class="btn-box" v-if="step == 'first'">
        <el-button type="primary" @click="submitHandel('formStepFirst')" size="small">保存，下一步</el-button>
      </div>
      <div class="btn-box" v-if="step == 'second'">
        <el-button @click="prevClick" size="small">上一步</el-button>
        <el-button @click="saveClick('formStepSecond')" size="small">保存</el-button>
        <el-button type="primary" @click="releaseClick('formStepSecond')" size="small">发布</el-button>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="content-left-phone">
          <div class="phone-top">
            <span class="phone-top-time">{{timeText}}</span>
          </div>
          <div class="phone-title">{{ title }}</div>
          <div class="phone-box">

            <div class="phone-container" :style="{
            'background-image': 'url(' + formStepSecond.backgroundImageUrl + ')'
          }">
              <!-- <div class="phone-container-back" v-if="0"></div> -->
              <div class="phone-container-center">
                <draggable v-model="phoneList" :move="onMove" handle=".mover" @start="startDrag" @end="endDrag">
                  <transition-group style="padding: 0 0 77px 0;">
                    <div v-for="(item, index) in phoneList" :key="item.id"
                      :class="'phone-container-center-item' + item.type">
                      <div v-if="item.type == '1' && item.url == ''" class="phone-container-text">
                        <span v-if="item.url == ''">建议图片宽度750px</span>
                      </div>
                      <div class="delete-box mover" v-if="item.type == '1' && item.url != ''">
                        <div class="delete-btn" @click.stop="deleteClick(item, index)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <img style="width: 100%;" class="img-box-url" :src="item.url" alt="" />
                      </div>
                      <div v-if="item.type == '2'" class="delete-box border-delete-box mover">
                        <div class="delete-btn" @click.stop="deleteClick(item, index)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <video controls style="width: 100%;object-fit: fill;">
                          <source :src="item.url" type="video/mp4" />
                        </video>
                      </div>
                      <div class="phone-back-item mover delete-box" v-if="item.type == '3' && item.flag == '1'">
                        <div class="delete-btn" @click.stop="deleteClick(item, index)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <div class="phone-item">
                          <span class="phone-item-title">姓名</span>
                          <span class="phone-item-text">请输入</span>
                        </div>
                        <div class="phone-item-border"></div>
                        <div class="phone-item">
                          <span class="phone-item-title">身份证号</span>
                          <span class="phone-item-text">请输入</span>
                        </div>
                      </div>
                      <div class="phone-back-item mover delete-box" v-if="item.type == '3' && item.flag == '2'">
                        <div class="delete-btn" @click.stop="deleteClick(item, index)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <div class="phone-item">
                          <span class="phone-item-title">请选择病种阶段</span>
                          <div class="phone-item-right">
                            <span class="phone-item-text">请选择</span>
                            <span class="el-icon-arrow-right"></span>
                          </div>
                        </div>
                      </div>
                      <div class="phone-back-item mover delete-box" v-if="item.type == '3' && item.flag == '3'">
                        <div class="delete-btn" @click.stop="deleteClick(item, index)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <div class="phone-item">
                          <span class="phone-item-title">体重</span>
                          <div class="phone-item-right">
                            <span class="phone-item-text">请输入</span>
                            <span class="phone-item-text1">kg</span>
                          </div>
                        </div>
                        <div class="phone-item-border"></div>
                        <div class="phone-item">
                          <span class="phone-item-title">身高</span>
                          <div class="phone-item-right">
                            <span class="phone-item-text">请输入</span>
                            <span class="phone-item-text1">cm</span>
                          </div>
                        </div>
                      </div>
                      <div class="warp-box mover" v-if="item.type == '5' && item.isAddRequire == '1'">
                        <div class="upload-box-title">
                          <div class="upload-box-text">
                            <div class="border-left"></div>
                            <div class="upload-box-text-title">上传图片</div>
                          </div>
                        </div>
                        <div class="uploadbox">
                          <div class="imgbox">
                            <div class="uploadBtn">
                              <img src="../../../assets/images/landPage/uploadPic.png" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="warp-box"> -->
                      <div class="shop-content mover" v-for="(el,eli) in item.goods" :key="eli">
                        <div class="delete-btn" @click.stop="deleteClickShop(index,eli,item)">
                          <img src="../../../assets/images/delete-icon.png" alt="" />
                        </div>
                        <div class="shop-box" :class="el.goodsState == 1?'shop-box-no':''">
                          <div class="shop-box-left">
                            <!-- <img
                              src="https://jiayi-dsicm-dev.oss-cn-hangzhou.aliyuncs.com/dsicm-medical/debf2b32f3cd431ea11c105015d1c6a0.jpeg"
                              alt="" /> -->
                            <img :src="el.goodsPicUrls[0]" alt="" />
                            <img class="shelves-icon" v-show='el.goodsState == 1'
                              src="../../../assets/images/landPage/shelves-icon.png" alt="" />
                            <!-- el.goodsPicUrl -->
                          </div>
                          <div class="shop-box-right">
                            <p class="shop-name">{{el.goodsName}}</p>
                            <p class="shop-tips">{{el.goodsDesc}}</p>
                            <div class="shop-message">
                              <p class="shop-message-price">￥<span>{{el.specCurrentPrice|money}}</span></p>
                              <div class="shop-message-number">
                                <span class="borderr" :class="el.count <= 0?'borderr-no':''"
                                  @click="reductionClick(index,eli,6)">-</span>
                                <el-input placeholder="" :disabled="true" v-model.trim="el.count"
                                  maxlength="2"></el-input>
                                <span class="borderl" :class="el.count >= 99?'borderr-no':''"
                                  @click="addClick(index,eli,6)">+</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- </div> -->
                      <!-- <div class="mover delete-box" :class="item.isButtonHover?'delete-position-box':''"
                        :style="{ bottom:item.isButtonHover && item.styleType == 1 ?(item.buttonHoverSort-1)*84+'px':item.isButtonHover && item.styleType == 2 ?(item.buttonHoverSort-1)*imgHeight+'px':0 }"
                        v-if="item.type == '4'"> -->
                      <div class="mover delete-box" :class="item.isButtonHover?'delete-position-box':''"
                        :style="{ bottom:item.isButtonHover?(item.buttonHoverSort-1)*84+'px':0 }"
                        v-if="item.type == '4'">
                        <div v-if="item.styleType == '2'">
                          <img style="width: 100%;" v-if="item.url" :src="item.url" @click="wechatBtnClick(index)"
                            alt="">
                          <div class="tips-btn" v-else @click="wechatBtnClick(index)">请上传图片</div>
                          <div class="delete-btn" @click.stop="deleteClick(item, index)">
                            <img src="../../../assets/images/delete-icon.png" alt="" />
                          </div>
                        </div>
                        <div class="interest-btn" v-else :style="{ color: item.fontColor, background: item.color }"
                          @click="wechatBtnClick(index)">
                          <div class="delete-btn" @click.stop="deleteClick(item, index)">
                            <img src="../../../assets/images/delete-icon.png" alt="" />
                          </div>
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <div class="warp-box" v-if="formStepSecond.isImg == '1'">
                  <div class="upload-box-title">
                    <div class="upload-box-text">
                      <div class="border-left"></div>
                      <div class="upload-box-text-title">上传图片</div>
                    </div>
                  </div>
                  <div class="uploadbox">
                    <div class="imgbox">
                      <div class="uploadBtn">
                        <img src="../../../assets/images/landPage/uploadPic.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-box">
          <div class="form-box-center" v-show="step == 'first'">
            <el-form :model="formStepFirst" label-width="170px" size="mini" :rules="rulesFormFirst" ref="formStepFirst"
              label-position="left" class="edit">
              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span><span class="span-text">基础设置</span>
                </div>
              </div>
              <el-form-item label="名称(用于管理):" prop="name">
                <div class="label-item">
                  <el-input placeholder="请输入名称" v-model.trim="formStepFirst.name" maxlength="50" show-word-limit>
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="标题(对外展示):" prop="title">
                <div class="label-item">
                  <el-input placeholder="请输入标题" v-model.trim="formStepFirst.title" maxlength="20" show-word-limit
                    @input="titleInput">
                  </el-input>
                </div>
              </el-form-item>
              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span><span class="span-text">归属设置</span>
                </div>
              </div>
              <el-form-item label="归属:" prop="belong">
                <div class="label-item">
                  <el-select v-model="formStepFirst.belong" value-key="diseaseId" @change="platFromBloneChange">
                    <el-option v-for="item in attributionList" :key="item.diseaseId" :label="item.diseaseName"
                      :value="item.diseaseId">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <div v-show="formStepFirst.belong"></div>
              <el-form-item label="机构:" prop="hospitalId" v-if="formStepFirst.belong == '1'">
                <div class="label-item">
                  <el-select v-model="formStepFirst.hospitalId" value-key="name" filterable @change="hospitalChange">
                    <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="团队:" prop="doctorTeamId" filterable v-if="formStepFirst.belong == '1'">
                <div class="label-item">
                  <el-select v-model="formStepFirst.doctorTeamId" value-key="diseaseId" filterable @change="teamChange">
                    <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="病种:" prop="diseaseId" v-if="formStepFirst.belong == '0'">
                <div class="label-item">
                  <el-select v-model="formStepFirst.diseaseId" value-key="suborderName" filterable
                    @change="diseaseNameChange">
                    <el-option v-for="item in diseaseList" :key="item.id" :label="item.suborderName" :value="item.id">
                    </el-option>
                  </el-select>                  
                </div>
                <div class="error-red" v-if="errorDiseaseId">病种已改变，请重新配置服务</div>
              </el-form-item>
              <el-form-item label="病种:" prop="diseaseId" v-if="formStepFirst.belong == '1'">
                <!-- :disabled="diseaseListBlone.length == 1" -->
                <div class="label-item">
                  <el-select v-model="formStepFirst.diseaseId" value-key="suborderName" filterable
                    @change="diseaseNameChange">
                    <el-option v-for="item in diseaseListBlone" :key="item.id" :label="item.suborderName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="应用范围:" prop="scope" v-if="formStepFirst.belong == '0'">
                <div class="label-item">
                  <el-radio-group v-model="formStepFirst.scope" @change="scopeApplicationChange">
                    <el-radio :label="0" :disabled="scope1">仅疗管</el-radio>
                    <el-radio :label="1" :disabled="scope2">应用全部</el-radio>
                    <el-radio :label="2">仅外链</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>

              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span>
                  <span class="span-text">实名设置</span>
                </div>
              </div>
              <el-form-item label="实名:" prop="realNameCert">
                <div class="label-item">
                  <el-radio-group v-model="formStepFirst.realNameCert">
                    <!-- :label="0" -->
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>

              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span>
                  <span class="span-text">分享设置</span>
                </div>
              </div>
              <el-form-item label="分享描述:" prop="shareDesc">
                <div class="label-item">
                  <el-input type="textarea" placeholder="请输入分享描述" v-model.trim="formStepFirst.shareDesc" maxlength="30"
                    show-word-limit>
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="分享图片:" prop="shareImageUrl">
                <div class="img-box">
                  <BaseUploadFile :fileSize="1" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="100"
                    :height="100" :beforeRemove="handleShareRemoveBack" :responseFn="sharePicChange"
                    :action="VUE_APP_WECHATBASE_URL" :widthHeightVali="true" :widthValue='100' :sizeOfThe="greaterEqual"
                    :heightValue="100" :data="{ path: 'dsicm-doctor', type: 'image', mediaId: '' }"
                    v-model="formStepFirst.shareImageUrl">
                  </BaseUploadFile>
                  <span class="tips-ospan" v-if="!formStepFirst.shareImageUrl">最大1M的png、jpg、jpeg。</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-box-center" v-show="step == 'second'">
            <el-form :model="formStepSecond" label-width="180px" size="mini" :rules="rulesFormSecond"
              ref="formStepSecond" label-position="left" class="edit">
              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span><span class="span-text">内容配置</span>
                </div>
              </div>
              <el-form-item label="图片:" prop="contentConfigImageUrl">
                <div class="configuration-img">
                  <div class="img-box">
                    <!-- <BaseUploadFile :limit="9" :checkMore="true" :multiple="true" :isShowTip="false" :fileSize="12"
                      :fileType="['png', 'jpg', 'jpeg', 'gif']" :size="80" :beforeRemove="beforeRemovePic"
                      :doRemoveNo="false" :widthHeightVali="true" :widthValue='750' :sizeOfThe="lessEqual"
                      :responseFn="handleIntroChange" :action="VUE_APP_WECHATBASE_URL" :data="{
                        path: 'dsicm-medical',
                        type: 'image',
                        mediaId: ''
                      }" v-model="formStepSecond.contentConfigImageUrl">
                    </BaseUploadFile> -->
                    <BaseUploadFile :limit="9" :checkMore="true" :multiple="true" :isShowTip="false" :fileSize="12"
                      :fileType="['png', 'jpg', 'jpeg', 'gif']" :size="80" :beforeRemove="beforeRemovePic"
                      :doRemoveNo="false" :responseFn="handleIntroChange" :action="VUE_APP_WECHATBASE_URL" :data="{
                        path: 'dsicm-medical',
                        type: 'image',
                        mediaId: ''
                      }" v-model="formStepSecond.contentConfigImageUrl">
                    </BaseUploadFile>
                    <span class="tips-ospan"
                      v-if="formStepSecond.contentConfigImageUrl.length <= 0">大小不超过12M，支持png/jpg/jpeg/gif。</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="视频:">
                <div class="video-box">
                  <div class="video-box-content" v-for="(item, i) in formStepSecond.videoList" :key="item">
                    <div class="mask-box">
                      <div class="mask-box-center">
                        <span class="big-icon" @click="bigVideoClick(i)"><i class="el-icon-zoom-in"></i></span>
                        <span class="delete-icon" @click="deleteVideoClick(i)"><i class="el-icon-delete"></i></span>
                      </div>
                    </div>
                    <video controls style="width: 80px;height:80px;object-fit: fill;">
                      <source :src="item" type="video/mp4" />
                    </video>
                  </div>
                  <el-upload v-loading="formDataLoading" class="avatar-uploader"
                    action="/api/dsicm-contact-platform/feign/file/upload" :show-file-list="false"
                    :data="{ path: 'dsicm-doctor' }" :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload" v-if="this.formStepSecond.videoList.length < 4">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <span class="tips-ospan" style="margin-left:10px;"
                    v-if="formStepSecond.videoList.length <= 0">时长不超过5分钟，大小不超过200MB，支持MP4格式。</span>
                </div>
              </el-form-item>
              <el-form-item label="游离表单:">
                <div class="label-item">
                  <el-select v-model="formStepSecond.freeForm" style="height:36px;" multiple value-key="diseaseId"
                    @change="formMessageChange">
                    <el-option v-for="item in formMessageList1" :key="item.diseaseId" :label="item.diseaseName"
                      :value="item">
                    </el-option>
                  </el-select>
                  <el-button type="primary" @click="determineClick1" size="small">确定</el-button>
                </div>
              </el-form-item>
              <div class="tips-title"><span class="tips-title-dote"></span><span class="tips-title-text">图片上传限制</span>
              </div>
              <el-form-item label="是否添加：" required>
                <div class="label-item">
                  <!-- <span style="margin-right:20px;">是否添加</span> -->
                  <el-radio v-model="formStepSecond.isAddRequire" label="1" @change="symptomsChange">是</el-radio>
                  <el-radio v-model="formStepSecond.isAddRequire" label="0" @change="symptomsChange">否</el-radio>
                </div>
                <div class="label-item label-item-Num">
                  <el-input placeholder="请输入最少图片上传数量" v-model.trim="formStepSecond.leastNum" @input="imgNumInput"
                    minlength="0" maxlength="2" style="width:240px;margin-right:20px;">
                    <template slot="append">张</template>
                  </el-input>
                  <el-input type="text" placeholder="请输入内容" v-model.trim="formStepSecond.imgText" width="200"
                    maxlength="20" show-word-limit style="width:200px;" :disabled="true"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="是否生成运营解读任务：" required v-if="formStepSecond.isAddRequire == '1'">
                <div class="label-item">
                  <el-radio-group v-model="formStepSecond.isGenerateInterpretationTask" @change="pretationTaskChange">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item label="按钮:" required>
                <div class="form-btn" @click="buttonClick">+ 按钮</div>
              </el-form-item>
              <el-form-item label="按钮类型:" prop="buttonType" v-if="btnFlag">
                <div class="label-item">
                  <el-radio-group v-model="formStepSecond.buttonType" @change="btnTypeChange">
                    <el-radio :disabled="btnTypeFlag" :label="1">领权益</el-radio>
                    <!-- <el-radio :disabled="disabledRadio" :label="1">领权益</el-radio> -->
                    <el-radio :label="2">跳链接</el-radio>
                    <el-radio :label="3">跳视频号</el-radio>
                    <el-radio :disabled="btnTypeFlagShop || formStepFirst.scope != 2" :label="4">商品服务</el-radio>
                    <!-- <el-radio :disabled="btnTypeFlag" :label="4">商品服务</el-radio> -->

                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item label="是否跳评估反馈:" prop="isJumpToFeedback"
                v-show="btnFlag && formStepSecond.buttonType == '1'">
                <div class="label-item">
                  <el-radio-group v-model="formStepSecond.isJumpToFeedback" @change="FeedbackRequireChange">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="
                  btnFlag && formStepSecond.buttonType == '1' && formStepFirst.belong != '1'">
                <el-form-item label="服务权益:" prop="rightServiceRules" v-if="formStepFirst.scope != '1'">
                  <div class="service-box" v-if="formStepFirst.scope == '0'">
                    <el-input placeholder="" style="min-width:200px;max-width:300px;"
                      v-model.trim="formStepSecond.rightService" :disabled="true">
                    </el-input>
                  </div>
                  <div class="service-box" v-else-if="formStepFirst.scope == '2'">
                    <div v-if="formStepFirst.diseaseId !='36112'" style="display: flex;width:380px;">
                      <el-input placeholder="" style="min-width:200px;max-width:300px;"
                        v-model.trim="formStepSecond.rightService" :disabled="true">
                      </el-input>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick"
                        v-if="formStepSecond.rightService && formStepSecond.rightService != ''">重新选择</a>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick" v-else>选择服务</a>
                    </div>
                    <div v-else style="display: flex;width:380px;">
                      <div class="service-box-name">
                        <el-tag v-for="(tag,index) in teamServiceNameList" :key="index" closable
                          :disable-transitions="false" :class="tag.deleted ?'el-tag-active':''"
                          @close="tagHandleClose(index)">
                          {{tag.name}}
                        </el-tag>
                      </div>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick"
                        v-if="(teamServiceNameList.length > 0)">重新选择</a>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick" v-else>选择服务</a>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="
                  btnFlag && formStepSecond.buttonType == '4' && formStepFirst.belong != '1'">
                <el-form-item label="服务权益:" v-if="formStepFirst.scope != '1'">
                  <div class="service-box" v-if="formStepFirst.scope == '0'">
                    <el-input placeholder="" style="min-width:200px;max-width:300px;" v-if="teamServices.length > 0"
                      v-model.trim="teamServices[0].name" :disabled="true">
                    </el-input>
                  </div>
                  <div class="service-box" v-else-if="formStepFirst.scope == '2'">
                    <div v-if="formStepFirst.diseaseId !='36112'" style="display: flex;width:380px;">
                      <!-- <el-input placeholder="" style="min-width:200px;max-width:300px;"
                        v-model.trim="teamServices[0].name" :disabled="true" v-if="teamServices.length > 0">
                      </el-input> -->
                      <div class="service-box-name">
                        <el-tag v-for="(tag,index) in teamServices" :key="index" closable :disable-transitions="false"
                          :class="tag.deleted ?'el-tag-active':''" @close="tagHandleCloseService(index)">
                          {{tag.name}}
                        </el-tag>
                      </div>
                      <!-- <div style="min-width:240px;max-width:300px;" v-else></div> -->
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick"
                        v-if="teamServices.length > 0">重新选择</a>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick" v-else>选择服务</a>
                    </div>
                    <div v-else style="display: flex;width:380px;">
                      <div class="service-box-name">
                        <el-tag v-for="(tag,index) in teamServices" :key="index" closable :disable-transitions="false"
                          :class="tag.deleted ?'el-tag-active':''" @close="tagHandleCloseService(index)">
                          {{tag.name}}
                        </el-tag>
                      </div>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick"
                        v-if="(teamServices.length > 0)">重新选择</a>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClick" v-else>选择服务</a>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="btnFlag && formStepSecond.buttonType == '4'">
                <el-form-item label="选择商品:" prop="rightService">
                  <div class="service-box">
                    <div style="display: flex;width:380px;">
                      <div class="service-box-name">
                        <el-tag v-for="(tag,index) in shopNameList" :key="index" closable :disable-transitions="false"
                          :class="tag.goodsState == 1 ?'el-tag-active':''" @close="tagHandleCloseShop(index)">
                          {{tag.goodsName}}
                        </el-tag>
                      </div>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClickShop"
                        v-if="(shopNameList.length > 0)">重新选择</a>
                      <a href="javascript:void(0);" class="choose-btn" @click="chooseClickShop" v-else>选择商品</a>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="商品数量自定义:" prop="definedGoodsCount"
                v-if="btnFlag && formStepSecond.buttonType == '4'">
                <div class="label-item">
                  <el-radio v-model="formStepSecond.definedGoodsCount" :disabled="shopNameList.length <= 0"
                    :label="true" @change="definedGoodsCountChange">是
                  </el-radio>
                  <el-radio v-model="formStepSecond.definedGoodsCount" :disabled="shopNameList.length <= 0"
                    :label="false" @change="definedGoodsCountChange">否
                  </el-radio>
                </div>
              </el-form-item>
              <!--   -->
              <el-form-item label="是否必传:" prop="isRequireUpload" v-if="btnFlag">
                <div class="label-item">
                  <el-radio v-model="formStepSecond.isRequireUpload" label="1" @change="symptomsRequireChange">是
                  </el-radio>
                  <el-radio v-model="formStepSecond.isRequireUpload" label="0" @change="symptomsRequireChange">否
                  </el-radio>
                </div>
              </el-form-item>
              <el-form-item label="视频号ID:" prop="channelId" v-if="btnFlag &&
                  formStepSecond.buttonType == '3'">
                <div class="label-item">
                  <el-select v-model="formStepSecond.channelId" value-key="diseaseId" @change="videoNumberChange">
                    <el-option v-for="item in videoNumberList" :key="item.videoId" :label="item.name"
                      :value="item.videoId">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>

              <el-form-item label="小程序:" prop="smallApp" v-if="btnFlag && formStepSecond.buttonType == '2'">
                <div class="label-item">
                  <el-select v-model="formStepSecond.smallApp" value-key="diseaseId" @change="wechatChange">
                    <el-option v-for="item in wechatList" :key="item.appId" :label="item.name" :value="item.appId">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="跳转页面链接:" prop="pageLink" v-if="btnFlag && formStepSecond.buttonType == '2'">
                <div class="label-item">
                  <el-input placeholder="请输入" v-model.trim="formStepSecond.pageLink" @input="pageInput">
                  </el-input>
                </div>
              </el-form-item>
              <!-- prop="styleType" -->
              <el-form-item label="按钮样式:" prop="styleType" v-if="btnFlag">
                <div class="label-item">
                  <el-radio-group v-model="formStepSecond.styleType" @change="styleTypeChange">
                    <el-radio :label="1">文字</el-radio>
                    <el-radio :label="2">图片</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item label="图片:" prop="btnImageUrl" v-if="btnFlag && formStepSecond.styleType == '2'">
                <div class="img-box">
                  <BaseUploadFile :fileSize="12" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg', 'gif']" :size="80"
                    :height="80" :beforeRemove="beforeRemovePicBtn" :responseFn="handleIntroChangeBtn"
                    :action="VUE_APP_WECHATBASE_URL" :widthHeightVali="true" :sizeOfThe="lessEqual" :widthValue='750'
                    :data="{ path: 'dsicm-doctor', type: 'image', mediaId: '' }" v-model="formStepSecond.btnImageUrl">
                  </BaseUploadFile>
                  <span class="tips-ospan">大小不超过12M，支持png/jpg/jpeg/gif。</span>
                </div>
              </el-form-item>
              <el-form-item label="按钮文字:" prop="buttonText" v-if="btnFlag && formStepSecond.styleType == '1'">
                <div class="label-item">
                  <el-input placeholder="请输入" v-model.trim="formStepSecond.buttonText" maxlength="20" show-word-limit
                    @input="btnTextInput">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="按钮悬停:" prop="evocativeForm" v-show="btnFlag">
                <div style="display: flex;">
                  <div class="label-item">
                    <el-radio-group v-model="formStepSecond.isButtonHover" @change="hoverButtonChange">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </div>
                  <span style="margin-left:20px;color:red;">文字按钮最大可添加2个，图片按钮最大可添加1个</span>
                </div>
              </el-form-item>
              <div>
                <el-form-item label="唤起表单:" prop="evocativeForm"
                  :rules="formStepSecond.buttonType == 2 ? [{required: false}]:rulesFormSecond.evocativeForm"
                  v-show="btnFlag">
                  <div class="label-item">
                    <el-radio-group v-model="formStepSecond.evocativeForm" @change="formChange">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="表单内容:" prop="buttonBindForm"
                :rules="formStepSecond.buttonType == 2 || formStepSecond.evocativeForm == 2 ? [{required: false}]:rulesFormSecond.buttonBindForm"
                v-show="btnFlag && formStepSecond.evocativeForm == '1'">
                <!-- <div class="label-item" v-if="formStepSecond.freeForm.length > 0">
                  <el-select v-model="formStepSecond.buttonBindForm" multiple value-key="diseaseId"
                    @change="platFromChange">
                    <el-option v-for="item in formMessageList2" :key="item.diseaseId" :label="item.diseaseName"
                      :value="item">
                    </el-option>
                  </el-select>
                  <el-popconfirm title="确定绑定后将清空未绑定按钮的表单？" v-if="formBtnFlag" @confirm="confirmClick"
                    @cancel="cancelClick">
                    <el-button type="primary" size="small" slot="reference" v-if="formBtnFlag">确定</el-button>
                  </el-popconfirm>
                </div> -->
                <div class="label-item">
                  <el-select v-model="formStepSecond.buttonBindForm" multiple value-key="diseaseId"
                    @change="platFromChange">
                    <el-option v-for="item in formMessageList2" :key="item.diseaseId" :label="item.diseaseName"
                      :value="item">
                    </el-option>
                  </el-select>
                  <el-button type="primary" size="small" @click="confirmClick" v-if="formBtnFlag">确定</el-button>
                </div>
              </el-form-item>
              <!-- required  -->
              <el-form-item label="文字颜色:" prop="colorText" v-if="btnFlag && formStepSecond.styleType == '1'">
                <div class="text-color-box">
                  <div class="text-color-item" :class="textColorIndex == index ?'active':''"
                    v-for="(item, index) in textColorList" :key="index" @click="textClick(index)">
                    <span :style="{ background: item.colorText }"></span>
                  </div>

                  <a class="custom-btn" href="javascript:void(0);">
                    <el-color-picker @change="textChange" v-model="color1"></el-color-picker>自定义颜色
                  </a>
                </div>
              </el-form-item>
              <!-- required -->
              <el-form-item label="按钮颜色:" prop="colorButton" v-if="btnFlag && formStepSecond.styleType == '1'">
                <div class="text-color-box">
                  <div class="text-color-item" :class="btnColorIndex == index ?'active':''"
                    v-for="(item, index) in btnColorList" :key="index" @click="btnClick(index)">
                    <span :style="{ background: item.colorText }"></span>
                  </div>
                  <a class="custom-btn" href="javascript:void(0);">
                    <el-color-picker @change="buttonChange" v-model="color2"></el-color-picker>自定义颜色
                  </a>
                </div>
              </el-form-item>
              <div class="ruleForm-title">
                <div class="ruleForm-title-left">
                  <span class="span-title"></span><span class="span-text">背景图</span>
                </div>
              </div>
              <el-form-item label="图片:">
                <div class="img-box">
                  <!-- <BaseUploadFile :fileSize="3" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="80"
                    :height="80" :beforeRemove="handleShareRemove" :responseFn="backPicChange"
                    :action="VUE_APP_WECHATBASE_URL" :widthHeightVali="true" :sizeOfThe="lessEqual" :widthValue='750'
                    :data="{ path: 'dsicm-doctor', type: 'image', mediaId: '' }"
                    v-model="formStepSecond.backgroundImageUrl"></BaseUploadFile> -->
                  <BaseUploadFile :fileSize="3" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="80"
                    :height="80" :beforeRemove="handleShareRemove" :responseFn="backPicChange"
                    :action="VUE_APP_WECHATBASE_URL" :data="{ path: 'dsicm-doctor', type: 'image', mediaId: '' }"
                    v-model="formStepSecond.backgroundImageUrl"></BaseUploadFile>
                  <span class="tips-ospan">大小不超过3M，支持png/jpg/jpeg。</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showAddQuestion" :close-on-click-modal="false" :before-close="handleClose" title="选择服务权益">
      <!-- <el-dialog visible.sync="true" :close-on-click-modal="false" :before-close="handleClose" title="选择服务权益"> -->
      <div class="title-box">
        <div class="title-box-list" :class="switchName == 'therapeuticTube'?'active':''"
          @click="serviceClick('therapeuticTube')">
          <span class="title-box-text">疗管服务</span><span class="border-bottom"
            v-if="switchName == 'therapeuticTube'"></span>
        </div>
        <div class="title-box-list" :class="switchName == 'doctor'?'active':''" @click="serviceClick('doctor')">
          <span class="title-box-text">医生服务</span><span class="border-bottom" v-if="switchName == 'doctor'"></span>
        </div>
      </div>
      <div class="dialog-main-content" v-show="switchName == 'therapeuticTube'">
        <div class="search-box">
          <el-input placeholder="请输入服务名称" v-model.trim="listQuery.keyword" maxlength="20"></el-input>
          <el-button @click="resetClick" size="small">重置</el-button>
          <el-button type="primary" @click="searchClick" size="small">搜索</el-button>
        </div>
        <div>
          <div class="main-content-list" style="max-height:430px;overflow:auto;">
            <el-table :data="tableData" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
              <el-table-column prop="name" label="服务名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="doctorTeamName" label="疗管团队" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="diseaseType" label="病种" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="commonStatus" label="公共领取" align="center">
                <template slot-scope="scope">
                  {{scope.row.commonStatus?'是':'否'}}
                </template>
              </el-table-column>
              <el-table-column prop="period" label="服务周期" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.period }}{{ scope.row.periodType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="服务单价" align="center"></el-table-column>
              <el-table-column prop="experiencePack" label="服务类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.experiencePack?'权益':'付费' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.flag" @click.native.prevent="
                      assessmentSend(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button>
                  <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                    已选
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
            <el-pagination background :current-page="listQuery.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="listQuery.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
      <div class="dialog-main-content" v-show="switchName == 'doctor'">
        <div class="search-box">
          <el-input placeholder="请输入服务名称" v-model.trim="listQueryDoctor.keyword" maxlength="20"></el-input>
          <el-button @click="resetClickDoctor" size="small">重置</el-button>
          <el-button type="primary" @click="searchClickDoctor" size="small">搜索</el-button>
        </div>
        <div>
          <div class="main-content-list" style="max-height:430px;overflow:auto;">
            <el-table :data="tableDataDoctor" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
              <el-table-column prop="hospitalName" label="线下机构" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="doctorTeamName" label="医生团队" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="name" label="服务名称" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="diseaseType" label="病种" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.diseaseType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="commonStatus" label="公共领取" align="center">
                <template slot-scope="scope">
                  {{scope.row.commonStatus?'是':'否'}}
                </template>
              </el-table-column>
              <el-table-column prop="periodType" label="服务周期" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.period }}{{ scope.row.periodType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="服务单价" align="center"></el-table-column>
              <el-table-column prop="experiencePack" label="服务类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.experiencePack?'权益':'付费' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.flag" @click.native.prevent="
                      assessmentSendDoctor(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button>
                  <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                    已选
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
            <el-pagination background :current-page="listQueryDoctor.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="listQueryDoctor.size" layout="total, sizes, prev, pager, next, jumper" :total="totalDoctor"
              @size-change="handleSizeChangeDoctor" @current-change="handleCurrentChangeDoctor" />
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showAddQuestionvideo" :close-on-click-modal="false" :before-close="handleCloseVideo"
      title="查看视频">
      <div class="dialog-main-content">
        <video controls style="width:100%;height:100%;object-fit: fill;" v-if="showAddQuestionvideo">
          <source :src="showAddQuestionvideoUrl" type="video/mp4" />
        </video>
      </div>
    </el-dialog>
    <!-- 商品弹窗 -->
    <el-dialog :visible.sync="showAddQuestionShop" :close-on-click-modal="false" :before-close="handleCloseShop"
      title="选择商品">
      <div class="dialog-main-content">
        <div class="search-box">
          <el-input placeholder="请输入商品名称" v-model.trim="listQueryShop.goodsName" maxlength="20"></el-input>
          <el-button @click="resetClickShop" size="small">重置</el-button>
          <el-button type="primary" @click="searchClickShop" size="small">搜索</el-button>
        </div>
        <div>
          <div class="main-content-list" style="max-height:430px;overflow:auto;">
            <el-table :data="tableDataShop" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
              <el-table-column prop="goodsName" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="goodsDesc" label="商品说明" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="goodsSpecVoList" label="当前价格" align="center">
                <template slot-scope="scope">
                  <span>{{  scope.row.goodsSpecVoList[0].specCurrentPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="goodsState" label="状态" align="center">
                <template slot-scope="scope">
                  <span>{{  scope.row.goodsState ==1 ? '已下架' : '已上架' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.flag" @click.native.prevent="
                      assessmentSendShop(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button>
                  <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                    已选
                  </el-button>
                  <!-- <el-button @click.native.prevent="
                      assessmentSendShop(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
            <el-pagination background :current-page="listQueryShop.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="listQueryShop.size" layout="total, sizes, prev, pager, next, jumper" :total="totalShop"
              @size-change="handleSizeChangeShop" @current-change="handleCurrentChangeShop" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template> 
<script>
// import { objFirst, objSecond, objThird } from "./constants.js";
import {
  termListData,
  hospitalList,
  doctorList,
  getTeamServicePage,
  categoryList,
  pagelandSave,
  pagelandSaveContent,
  publish,
  pagelandDetail,
  description,
  therapistByDiseaseId,
  listUsedDiseaseType,
  getDiseaseIdListById,
  shopPage,
  shopDetail,
  getLandingpageGoodsStatusByLandingPageId
} from "../api/landPage";
import { wechatType } from "@/api/customService.js";
import draggable from "vuedraggable";
import { imgBaseURL } from "@/utils/common";
export default {
  components: {
    draggable
  },
  data() {
    // let validatePass = (rule, value, callback) => {
    //   if (value == '') {
    //       callback(new Error('请选择病种'));
    //     } else if (value != this.oldDiseaseId) {
    //       callback(new Error('病种已改变，请重新配置服务'));
    //     } else {
    //       callback();
    //     }
    //   };
    return {
      imgBaseURL: imgBaseURL,
      formStepFirst: {
        //表单value值
        name: "", //名称
        title: "", //标题
        belong: 0, //归属
        // hospitalName: "", //机构名称
        hospitalId: "", //机构id
        // doctorTeamName: "", //团队名称
        doctorTeamId: "", //团队id
        // diseaseName: "", //病种
        diseaseId: "", //病种id
        scope: 0, //应用范围
        realNameCert: true,
        shareDesc: "", //分享描述
        shareImageUrl: "" //分享图片
      },
      formStepSecond: {
        //表单value值
        videoList: [], //视频
        freeForm: "", //游离表单 freeForm
        buttonType: 2, //按钮类型
        smallApp: "", //小程序
        pageLink: "", //跳转页面链接
        buttonText: "", //按钮文字
        evocativeForm: 2, //唤起表单
        buttonBindForm: [], //按钮表单内容
        colorText: "#ffffff", //文字颜色
        buttonNum: "", //请选择按钮
        colorButton: "#0CB79F", //按钮颜色
        rightService: "", //服务权益
        rightServiceId: "", //服务权益id
        interestName: "", //服务权益名称
        backgroundImageUrl: "", //背景图片
        contentConfigImageUrl: [],
        imgNum: 1,
        imgText: "请上传至少 1 张图片",
        isRequireUpload: "1", //是否必传
        isJumpToFeedback: false, //是否跳转评估
        leastNum: 1, //最少图片上传数量
        styleType: 1, //按钮样式
        btnImageUrl: "", //图片
        isAddRequire: "0", //是否生成运营解读任
        channelId: null, //视频号ID
        isGenerateInterpretationTask: false, //是否生成运营解读任务
        isButtonHover: false, //按钮是否悬停
        rightServiceRules: "", //判断是否展示服务权益的报错
        definedGoodsCount: 1 //商品数量自定义
      },
      rulesFormFirst: {
        //验证表单
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        belong: [{ required: true, message: "请选择归属", trigger: "change" }],
        hospitalId: [
          { required: true, message: "请选择机构", trigger: "change" }
        ],
        doctorTeamId: [
          { required: true, message: "请选择团队", trigger: "change" }
        ],
        diseaseId: [
          { required: true, message: "请选择病种", trigger: "change" }
          // {validator: validatePass, trigger: "change" }
          
        ],
        scope: [
          { required: true, message: "请选择应用范围", trigger: "change" }
        ],
        realNameCert: [
          { required: true, message: "请选择是否实名", trigger: "blur" }
        ],
        shareDesc: [
          { required: true, message: "请填写分享描述", trigger: "blur" }
        ],
        shareImageUrl: [
          { required: true, message: "请上传图片", trigger: "change" }
        ]
      },
      rulesFormSecond: {
        //验证表单
        buttonType: [
          { required: true, message: "请选择按钮类型", trigger: "change" }
        ],
        smallApp: [
          { required: true, message: "请选择小程序", trigger: "change" }
        ],
        pageLink: [
          { required: true, message: "请填写跳转页面链接", trigger: "blur" }
        ],
        rightServiceRules: [
          { required: true, message: "请选择服务权益", trigger: "change" }
        ],
        buttonText: [
          { required: true, message: "请输入按钮文字", trigger: "change" }
        ],
        evocativeForm: [
          { required: true, message: "请选择是否唤起表单", trigger: "blur" }
        ],
        buttonBindForm: [
          { required: true, message: "请选择表单内容", trigger: "change" }
        ],
        freeForm: [
          { required: true, message: "请选择表单内容", trigger: "change" }
        ],
        colorText: [{ required: true, message: "请选择文字颜色", trigger: "" }],
        buttonNum: [
          { required: true, message: "请选择按钮", trigger: "change" }
        ],
        colorButton: [
          { required: true, message: "请选择按钮颜色", trigger: "" }
        ],
        contentConfigImageUrl: [
          { required: true, message: "请上传图片", trigger: "change" }
        ],
        channelId: [
          { required: true, message: "请选择视频号ID", trigger: "change" }
        ],
        btnImageUrl: [
          { required: true, message: "请上传图片", trigger: "change" }
        ],
        styleType: [
          { required: true, message: "请选择按钮样式", trigger: "change" }
        ],
        isRequireUpload: [
          { required: true, message: "请选择是否必传", trigger: "change" }
        ],
        isJumpToFeedback: [
          { required: true, message: "请选择是否跳转评估", trigger: "change" }
        ]
      },
      attributionList: [
        //归属
        {
          diseaseName: "平台",
          diseaseId: 0
        },
        {
          diseaseName: "医生团队",
          diseaseId: "1"
        }
      ],
      diseaseList: [
        //病种
      ],
      institutionList: [
        //机构
      ],
      teamList: [
        //团队
      ],
      formMessageList1: [
        //归属
        {
          diseaseName: "身份信息",
          diseaseId: "1"
        },
        {
          diseaseName: "病种阶段",
          diseaseId: "2"
        },
        {
          diseaseName: "BMI",
          diseaseId: "3"
        }
      ],
      formMessageList2: [
        //归属
        {
          diseaseName: "身份信息",
          diseaseId: "1"
        },
        {
          diseaseName: "病种阶段",
          diseaseId: "2"
        },
        {
          diseaseName: "BMI",
          diseaseId: "3"
        }
      ],
      formMessageListAll: [
        //总的表单 用来筛选剩余表单
        {
          diseaseName: "身份信息",
          diseaseId: "1"
        },
        {
          diseaseName: "病种阶段",
          diseaseId: "2"
        },
        {
          diseaseName: "BMI",
          diseaseId: "3"
        }
      ],
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload", //上传图片的接口路径
      step: "first", //第一步
      textColorList: [
        //颜色选择器
        {
          value: 1,
          colorText: "#1A7BFC"
        },
        {
          value: 2,
          colorText: "#0CB79F"
        },
        {
          value: 3,
          colorText: "#EE3F47"
        },
        {
          value: 4,
          colorText: "#ffffff"
        },
        {
          value: 5,
          colorText: "#333333"
        }
      ],
      btnColorList: [
        //颜色选择器
        {
          value: 1,
          colorText: "#1A7BFC"
        },
        {
          value: 2,
          colorText: "#0CB79F"
        },
        {
          value: 3,
          colorText: "#EE3F47"
        },
        {
          value: 4,
          colorText: "#ffffff"
        },
        {
          value: 5,
          colorText: "#333333"
        }
      ],
      formFlag: false, //表单
      btnFlag: false, //按钮
      color1: null, //文字颜色
      color2: null, //按钮颜色
      phoneList: [],
      index: 0,
      wechatList: [], //小程序数组
      imgPath: process.env.VUE_APP_OSS_URL,
      formDataLoading: false, //上传图片loading
      customTextColorList: [], //自定义文字颜色
      customBtnColorList: [], //自定义按钮颜色
      dragFlag1: false,
      dragFlag2: false,
      dragFlag3: false,
      title: "这里是标题", //标题
      dialogTitle: "标题",
      showAddQuestion: false,
      tableData: [], //弹窗选择疗管服务
      tableDataDoctor: [], //弹窗选择医生服务
      tableDataShop: [], //弹窗选择商品
      listQuery: {
        //弹窗
        current: 1,
        isExperiencePack: true,
        isTherapistService: true,
        diseaseId: null,
        size: 10,
        keyword: null,
        searchField: 1,
        orderType: 1
      },
      listQueryDoctor: {
        //弹窗
        current: 1,
        isExperiencePack: true,
        isTherapistService: false,
        diseaseId: null,
        size: 10,
        keyword: null,
        searchField: 1,
        orderType: 1
      },
      listQueryShop: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        goodsName: null
      },
      total: 0,
      totalDoctor: 0,
      totalShop: 0,
      interestName: null,
      id: null,
      flagbtn: true, //
      btnFontcolorId: null, //文字颜色id
      btnColorId: null, //按钮颜色id
      btndescription: "",
      btnFontdescription: "",
      diseaseNameChangeId: null, //疾病类型id
      diseaseNameService: null, //选中的服务
      scope1: false, //判断应用范围的仅疗管是否disable
      scope2: false, //判断应用范围的应用全部是否disable
      listUsedDiseaseTypeList: [], //
      showAddQuestionvideo: false, //查看视频弹窗
      showAddQuestionvideoUrl: null, //查看视频链接
      textColorIndex: 3, //新增的按钮字体颜色默认选中第四个
      btnColorIndex: 1, //新增的按钮颜色默认选中第四个
      diseaseListBlone: [], //病种
      lessEqual: "lessEqual", //图片限制不超过
      greaterEqual: "greaterEqual",
      timeText: "9:41", //默认时间
      formButtonTypeFlag: false,
      formButtonTypeList: [],
      selectBtnArea: {},
      formArrList: [],
      arrForm: [],
      choseBtnIndex: 0,
      value11List: [],
      formBtnFlag: true,
      idArr: "",
      arrList: [],
      btnTypeFlag: false, //领取权益按钮只能添加一个
      btnTypeFlagShop: false, //商品服务按钮只能添加一个
      videoValidation: true, //视频验证
      promptError: true,
      videoNumberList: [{ name: "智联医健", videoId: "sphgFoicGz39gnZ" }], //选择视频号
      teamServiceNameList: [], //选中的服务权益的数组
      teamServices: [], //选中的商品按钮服务权益的数组
      switchName: "therapeuticTube", //弹窗切换的tab
      rightServiceObj: {
        //用来切换归属和应用范围清空之后再赋值 归属位平台
        rightService: "", //服务权益
        rightServiceId: "", //服务权益id
        interestName: "", //服务权益名称
        schemeType: 1 //服务权益名称
      },
      rightServiceObjDoctor: {
        //用来切换归属和应用范围清空之后再赋值  归属为医生团队
        rightService: "", //服务权益
        rightServiceId: "", //服务权益id
        interestName: "", //服务权益名称
        schemeType: 1 //服务权益名称
      },
      suborderCode: null, //选中病种的code
      imgHeight: 0, //判断上传图片的高度
      showAddQuestionShop: false, //商品弹窗的展示与隐藏字段
      shopNameList: [], //选中的商品的数组
      btnFlagServer: false, //是否点击保存按钮
      rightServiceRules: "", //判断是否展示服务权益的报错
      searchFlag: false, //未点击搜索
      searchFlagDoctor: false, //点击搜索
      oldDiseaseId:null,//详情页面的病种
      errorDiseaseId:false,//判断病种是否切换
    };
  },
  computed: {},
  watch: {
    phoneList: {
      handler() {
        let btnarr = this.phoneList.filter(v => v.type == 4);
        let arr = this.phoneList.filter(v => v.buttonType == 1);
        let arrShop = this.phoneList.filter(v => v.buttonType == 4);
        let arrKey = Object.keys(this.selectBtnArea);
        this.btnTypeFlag = false;
        this.btnTypeFlagShop = false;
        btnarr.forEach((item, index) => {
          if (item.buttonType == 1) {
            this.btnTypeFlag = true;
            this.btnTypeFlagShop = true;
          }
          if (item.buttonType == 4) {
            this.btnTypeFlagShop = true;
            this.btnTypeFlag = true;
          }
        });
      },
      deep: true,
      immediated: true
    }
    // "formStepFirst.scope": {
    //   //监听应用范围的值，仅外链添加
    //   deep: true,
    //   handler: function(newV, oldV) {
    //     if (newV == 2) {
    //       let objDisease = {
    //         diseaseAlternateName: null,
    //         id: "36112",
    //         strategic: true,
    //         suborderCode: "0",
    //         suborderName: "通用"
    //       };
    //       let index = this.diseaseList.findIndex(item => {
    //         item.id == "36112";
    //       });
    //       if (index <= 0) {
    //         let index = this.diseaseList.findIndex(item => {
    //           item.id == "36112";
    //         });
    //         this.diseaseList.splice(index, 1);
    //         this.diseaseList[this.diseaseList.length] = objDisease;
    //       } else {
    //       }
    //     } else {
    //       let index = this.diseaseList.findIndex(item => {
    //         item.id == "36112";
    //       });
    //       this.diseaseList.splice(index, 1);
    //     }
    //   }
    // }
  },
  created() {
    this.timeminutes();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;

      this.step = "first";
      // this.step = "second";
      this.listUsedDiseaseTypeRequest().then(res => {
        this.pagelandDetailRequest();
      });
      this.detailStatus = true;
      // this.step = "second";
    } else {
      this.detailStatus = false;
    }
    this.formButtonTypeFun();
    // this.idFun();
  },
  mounted() {
    this.getWechatType();
    this.termListDataRequest();
    this.hospitalListRequest();
    this.categoryListRequest();
    this.listUsedDiseaseTypeRequest();
  },
  methods: {
    btnTypeFun() {
      let btnarr = this.phoneList.filter(v => v.type == 4);
      let arr = this.phoneList.filter(v => v.buttonType == 1);
      let arrShop = this.phoneList.filter(v => v.buttonType == 4);
      let arrKey = Object.keys(this.selectBtnArea);
      // if (arrKey.length > 0) {
      //   if (arr.length == 1) {
      //     btnarr.forEach(v => {
      //       if (
      //         v.id == this.selectBtnArea.id &&
      //         this.selectBtnArea.buttonType == 1
      //       ) {
      //         this.btnTypeFlag = false;
      //       } else {
      //         this.btnTypeFlag = true;
      //       }
      //     });
      //   } else {
      //     this.btnTypeFlag = false;
      //   }
      // }
      // if (arrShop.length == 1) {
      //   btnarr.forEach(v => {
      //     if (
      //       v.id == this.selectBtnArea.id &&
      //       this.selectBtnArea.buttonType == 4
      //     ) {
      //       this.btnTypeFlagShop = true;
      //     } else {
      //       this.btnTypeFlagShop = false;
      //     }
      //   });
      // } else {
      //   this.btnTypeFlagShop = false;
      // }
      this.btnTypeFlag = false;
      this.btnTypeFlagShop = false;
      btnarr.forEach((item, index) => {
        if (item.buttonType == 1) {
          this.btnTypeFlag = true;
          this.btnTypeFlagShop = true;
        }
        if (item.buttonType == 4) {
          this.btnTypeFlagShop = true;
          this.btnTypeFlag = true;
        }
      });
    },
    timeminutes() {
      let date = new Date();
      let sign2 = ":";
      let hour = date.getHours(); // 时
      let minutes = date.getMinutes(); // 分
      let minutesNum = "";
      if (minutes >= 10) {
        minutesNum = minutes;
      } else {
        minutesNum = "0" + minutes;
      }
      this.timeText = hour + ":" + minutesNum;
    },
    idFun() {
      //自己建id
      let date = new Date().valueOf();
      let num = parseInt(1000000 * Math.random());
      let strId = date.toString() + num.toString();
      return strId;
    },
    handleClose() {
      this.showAddQuestion = false;
    },
    handleCloseShop() {
      this.showAddQuestionShop = false;
    },
    handleShareRemove() {
      this.formStepSecond.backgroundImageUrl = "";
    },
    handleShareRemoveBack() {
      this.formStepFirst.shareImageUrl = "";
    },
    beforeRemovePicBtn() {
      this.formStepSecond.btnImageUrl = "";
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].url = "";
      this.$forceUpdate();
    },
    titleInput(e) {
      //标题输入框
      this.title = e;
    },
    // 分享图片
    sharePicChange(response) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
      }
      return url;
    },
    backPicChange(response) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
      }
      this.formStepSecond.backgroundImageUrl = url;
      return url;
    },
    handleIntroChangeBtn(response, file) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
        let imgObj = new Image();
        imgObj.src = url;
        // imgObj.src =
        //   "https://jiayi-dsicm-sit.oss-cn-hangzhou.aliyuncs.com/dsicm-doctor/5ecbc088bbe349db8d910e1d90d09836.png";
        imgObj.onload = () => {
          this.imgHeight = imgObj.height;
        };
        this.choseBtnIndex = this.phoneList.findIndex(item => {
          return item.id == this.selectBtnArea.id;
        });
        this.phoneList[this.choseBtnIndex].url = url;
        this.formStepSecond.btnImageUrl = url;
        // this.phoneList.push(obj);
      }
      return url;
    },

    diseaseNameChange(value) {
      // this.formStepSecond.rightService = "";
      // this.rightServiceObj = {
      //   //用来切换归属和应用范围清空之后再赋值 归属位平台
      //   rightService: "", //服务权益
      //   rightServiceId: "", //服务权益id
      //   interestName: "", //服务权益名称
      //   schemeType: 1 //服务权益名称
      // };
      // this.rightServiceObj.rightServiceId = "";
      // this.rightServiceObj.rightService = "";
      // //
      // this.phoneList.forEach((item, indedx) => {
      //   if (item.type == 4) {
      //     if (item.buttonType == 1) {
      //       item.teamServiceId = null;
      //       item.teamServiceName = null;
      //       item.doctorSchemeId = null;
      //       item.doctorTeamId = null;
      //       item.experiencePack = null;
      //       item.teamServiceList = [];
      //     } else if (item.buttonType == 4) {
      //       item.goods = [];
      //       item.teamServices = [];
      //     }
      //   }
      // });
      if(this.id){
        if(this.oldDiseaseId == value){
          this.errorDiseaseId = false
        }else{
          this.errorDiseaseId = true;
        }
      }
     
      this.listUsedDiseaseTypeRequest();
      let arr = this.diseaseList.filter(item => {
        return item.id == value;
      });
      if (arr.length > 0) {
        this.suborderCode = arr[0].suborderCode;
      }
      this.diseaseDiagnosis(arr, value);
      // this.interestName = "";

      // this.teamServiceNameList = [];
      // this.teamServices = [];
      this.$forceUpdate();
    },
    diseaseDiagnosis(arr, value) {
      this.diseaseNameChangeId = value;
      this.listQuery.diseaseId = value;
      this.listQueryDoctor.diseaseId = value;
      if (arr.length > 0) {
        if (arr[0].strategic != 1) {
          //非推荐病种
          this.scope1 = true;
          this.scope2 = true;
          this.formStepFirst.scope = 2;
          if (arr[0].id == "36112") {
            //通用病种
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          }
          if (this.formStepFirst.scope == 2) {
            //仅外链
            this.getTeamServicePageRequest();
          } else {
            //仅疗管 应用全部
            this.therapistByDiseaseIdRequest();
          }
        } else {
          let flag = false;
          this.listUsedDiseaseTypeList.forEach((item, index) => {
            if (item == value) {
              flag = true;
            }
          });
          if (flag) {
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          } else {
            this.scope1 = false;
            this.scope2 = false;
            this.formStepFirst.scope = 0;
          }
          if (arr[0].id == "36112") {
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          }
          if (this.formStepFirst.scope == 2) {
            //仅外链
            this.getTeamServicePageRequest();
          } else {
            //仅疗管 应用全部
            this.therapistByDiseaseIdRequest();
          }
        }
      }
    },
    diseaseScope(status) {
      if (this.formStepFirst.scope == 2) {
        //仅外链
        if (this.rightServiceObj.schemeType == 1) {
          //疗管服务
          this.switchName = "therapeuticTube";
        } else {
          //医生服务
          this.switchName = "doctor";
        }
        if (status) {
          this.getTeamServicePageRequest();
        }
      } else {
        //仅疗管 应用全部
        if (status) {
          if (this.formStepFirst.belong != "1") {
            if(this.formStepSecond.buttonType == 1 || this.formStepSecond.buttonType == 4){
              this.therapistByDiseaseIdRequest();
            }            
          }
        }
      }
    },
    scopeApplicationChange(value) {
      this.formStepSecond.rightService = "";
      this.rightServiceObj = {
        //用来切换归属和应用范围清空之后再赋值 归属位平台
        rightService: "", //服务权益
        rightServiceId: "", //服务权益id
        interestName: "", //服务权益名称
        schemeType: 1 //服务权益名称
      };
      this.rightServiceObj.rightServiceId = "";
      this.rightServiceObj.rightService = "";
      //
      this.phoneList.forEach((item, indedx) => {
        if (item.type == 4) {
          if (item.buttonType == 1) {
            item.teamServiceId = null;
            item.teamServiceName = null;
            item.doctorSchemeId = null;
            item.doctorTeamId = null;
            item.experiencePack = null;
            item.teamServiceList = [];
          } else if (item.buttonType == 4) {
            item.goods = [];
            item.teamServices = [];
          }
        }
      });
      if (value == 2) {
        //仅外链
        if (this.listQuery.diseaseId || this.listQueryDoctor.diseaseId) {
          this.getTeamServicePageRequest();
        }
      } else {
        //仅疗管
        if (this.diseaseNameChangeId) {
          this.therapistByDiseaseIdRequest();
        }
      }
    },
    hospitalChange(value) {
      this.teamList = [];
      this.formStepFirst.doctorTeamId = null;
      this.doctorListRequest(value);
    },
    teamChange(value) {
      //
      this.formStepFirst.diseaseId = null;
      this.getDiseaseIdListByIdRequest(value);
    },
    textClick(index) {
      //选择文字颜色
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.textColorIndex = index;
      this.phoneList[this.choseBtnIndex].fontColor = this.textColorList[
        index
      ].colorText;
      this.formStepSecond.colorText = this.textColorList[index].colorText;
    },
    btnClick(index) {
      //选择按钮颜色
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.btnColorIndex = index;
      this.phoneList[this.choseBtnIndex].color = this.btnColorList[
        index
      ].colorText;
      this.formStepSecond.colorButton = this.btnColorList[index].colorText;
    },
    chooseClick() {
      //重新选择
      this.showAddQuestion = true;
      this.listQuery.keyword = null;
      this.listQueryDoctor.keyword = null;
      this.getTeamServicePageRequest();
    },
    chooseClickShop() {
      this.shopPageRequest();
      this.showAddQuestionShop = true;
    },
    diseaseDiagnosisNew(arr, value) {
      this.diseaseNameChangeId = value;
      this.listQuery.diseaseId = value;
      this.listQueryDoctor.diseaseId = value;
      if (arr.length > 0) {
        if (arr[0].strategic != 1) {
          //非战略病种
          this.scope1 = true;
          this.scope2 = true;
          this.formStepFirst.scope = 2;
          if (arr[0].id == "36112") {
            //通用病种
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          }
          if (this.formStepFirst.scope == 2) {
            //仅外链
            this.getTeamServicePageRequest();
          } else {
            //仅疗管 应用全部
            // this.therapistByDiseaseIdRequest();
          }
        } else {
          let flag = false;
          this.listUsedDiseaseTypeList.forEach((item, index) => {
            if (item == value) {
              flag = true;
            }
          });
          if (flag) {
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          } else {
            this.scope1 = false;
            this.scope2 = false;
            // this.formStepFirst.scope = 0;
          }
          if (arr[0].id == "36112") {
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
          }
          if (this.formStepFirst.scope == 2) {
            //仅外链
            this.getTeamServicePageRequest();
          } else {
            //仅疗管 应用全部
            // this.therapistByDiseaseIdRequest();
          }
        }
      }
    },
    buttonClick() {
      //点击增加按钮
      if (this.btnFlag) {
        this.formStepSecond.buttonNum = true;
      }
      let list = this.phoneList.filter(item => item.type == 4);
      // if (list.length > 5) {
      //   this.$message.error("最多只能添加六个按钮");
      //   return false;
      // }
      this.promptError = false;
      this.diseaseScope(true);
      this.btnFlag = true;
      //清空表单
      this.formStepSecond.buttonType = 2; //按钮类型
      this.formStepSecond.rightService = ""; //服务权益
      this.formStepSecond.rightServiceRules = ""; //服务权益是否填写
      this.formStepSecond.buttonText = ""; //按钮文字
      this.formStepSecond.evocativeForm = 2; //唤起表单
      this.formStepSecond.buttonBindForm = []; //按钮表单内容
      this.formStepSecond.colorText = "#ffffff"; //文字颜色
      this.formStepSecond.colorButton = "#0CB79F"; //按钮颜色
      this.formStepSecond.smallApp = ""; //小程序
      this.formStepSecond.pageLink = ""; //跳转页面链接
      this.formStepSecond.isRequireUpload = "1"; //是否必传
      this.formStepSecond.definedGoodsCount = true; //商品数量自定义
      // this.formStepSecond.leastNum = 1; //传的最少张数
      this.formStepSecond.styleType = 1; //默认文字 1文字  2图片
      this.formStepSecond.btnImageUrl = ""; //按钮背景图
      this.formStepSecond.channelId = null; //按钮背景图
      this.formStepSecond.isJumpToFeedback = false; //是否跳转评估反馈
      this.formStepSecond.isButtonHover = false; //是否跳转评估反馈

      // this.teamServices = [];

      this.interestName = "";
      let obj4 = {
        type: 4,
        buttonType: 2, //"按钮类型 1: 领权益  2: 跳链接", 3: 跳视频号",
        text: "默认按钮" + (list.length + 1), //"按钮文字",
        fontColor: "#ffffff", // "#000000  字体颜色",
        color: "#0CB79F", // "#000000  按钮颜色",
        // bindForm: obj1.id + "," + obj2.id + "," + obj3.id, // "3,5,6  关联的表单可能会有多个，用逗号拼接",
        bindForm: "", // "3,5,6  关联的表单可能会有多个，用逗号拼接",
        teamServiceId: "", // 12312312, //选择的服务Id
        teamServiceName: "", // 12312312, //选择的服务名称
        teamServiceList: [], //多选的领权益服务
        teamServices: [], //多选的商品按钮服务
        goods: [], //多选的商品
        schemeType: "", // 12312312, //选择的服务名称
        appId: "", //小程序Id
        jumpUrl: "", //"/page/index", //小程序页面跳转路径
        evocativeForm: 2, //"/page/index", //是否唤起表单
        sort: 4,
        dragFlag4: true,
        id: this.idFun(),
        bindFormTypeMap: {},
        arrForm: [],
        btnSort: this.phoneList.map(v => v.type == 4).length + 1,
        channelId: "sphgFoicGz39gnZ", //视频号ID
        url: null, //按钮图片
        styleType: 1, //按钮图片
        isRequireUpload: 1, //是否必传
        isJumpToFeedback: false, //是否跳评估反馈
        isButtonHover: false, //是否跳评估反馈
        definedGoodsCount: true //商品数量自定义
      };
      this.phoneList.push(obj4);
      this.selectBtnArea = obj4;
      this.phoneList.forEach((item, index) => {
        if (item.type == 3 && item.bind) {
          item.flag = 0;
        }
      });
      this.index = this.phoneList.length - 1;
      this.textColorIndex = 3;
      this.btnColorIndex = 1;
      // this.selectBtnArea = this.phoneList[this.phoneList.length - 1];
      this.formStepSecond.buttonBindForm = [];
    },
    textChange(e) {
      //文字自定义颜色
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      if (e) {
        if (this.textColorList.length > 9) {
          this.textColorList.splice(5, 1);
        }
        let obj = {
          value: this.textColorList.length,
          colorText: e
        };
        this.textColorList.push(obj);
        this.textColorIndex = this.textColorList.length - 1;
        this.phoneList[this.choseBtnIndex].fontColor = e;
        if (this.customTextColorList.length > 5) {
          this.customTextColorList.splice(0, 1);
        }
        this.customTextColorList.push(obj);

        let descriptionTextArr = this.textColorList.map(item => item.colorText);
        let objColor = {
          code: this.btnFontcolorId,
          description: descriptionTextArr.toString()
        };
        description(objColor).then(res => {
          if (res.code == 0) {
          }
        });
      }
    },
    buttonChange(e) {
      //按钮自定义颜色
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      if (e) {
        if (this.btnColorList.length > 9) {
          this.btnColorList.splice(5, 1);
        }
        let obj = {
          value: this.btnColorList.length,
          colorText: e
        };
        this.btnColorList.push(obj);
        this.btnColorIndex = this.btnColorList.length - 1;
        this.phoneList[this.choseBtnIndex].color = e;

        if (this.customBtnColorList.length > 5) {
          this.customBtnColorList.splice(0, 1);
        }
        this.customBtnColorList.push(obj);
        let descriptionBtnArr = this.btnColorList.map(item => item.colorText);

        let objColor = {
          code: this.btnColorId,
          description: descriptionBtnArr.toString()
        };
        description(objColor).then(res => {
          if (res.code == 0) {
          }
        });
      }
    },
    btnTextInput(e) {
      //按钮文字
      //   this.phoneList[this.index].formList[3].text = e;
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].text = e;
    },
    wechatBtnClick(index) {
      //左边微信页面里的按钮
      if (this.step == "first") {
        return false;
      }
      this.shopNameList = [];
      this.formStepSecond.buttonBindForm = [];
      this.index = index;
      this.selectBtnArea = this.phoneList[index];
      this.formBtnFlag = true;

      this.promptError = false;

      // this.diseaseScope(true);
      this.btnFlag = true;
      // this.formStepSecond.buttonType = this.phoneList[this.index].buttonType; //按钮类型
      this.assignmentFun(this.index, this.phoneList[this.index]); //赋值方法
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.diseaseScope(true);
      this.showBtnFun(index);
      this.btnTypeFun(); //判断按钮是不是唯一的权益或者商品
    },
    showBtnFun(index) {
      this.phoneList.forEach((item, index) => {
        if (item.type == 3 && item.bind) {
          item.flag = 0;
        }
      });
      if (
        this.phoneList[index].bindForm &&
        this.phoneList[index].bindForm != ""
      ) {
        let showArr = this.phoneList[index].bindForm.split(",");
        this.phoneList.forEach(element => {
          if (showArr.indexOf(element.id) > -1) {
            element.flag = element.formType;
          }
        });
      }
    },
    FilterData(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      var c = b;
      for (var i = 0; i < a.length; i++) {
        if (c.indexOf(a[i].id) > -1) {
          result.push(a[i]);
        }
      }
      return result;
    },
    btnTypeChange(e) {
      this.arrList = [];
      //选择按钮类型
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.formStepSecond.buttonType = e;
      this.phoneList[this.choseBtnIndex].buttonType = e;
      this.formStepSecond.rightService = "";
      // this.rightServiceObj.rightServiceId = "";
      this.teamServiceNameList = [];
      this.teamServices = [];
      this.shopNameList = [];
      if(this.phoneList[this.choseBtnIndex].buttonType == 1 || this.phoneList[this.choseBtnIndex].buttonType == 4){

      }
      // this.rightServiceObj = {
      //   //用来切换归属和应用范围清空之后再赋值
      //   rightService: "", //服务权益
      //   rightServiceId: "", //服务权益id
      //   interestName: "" //服务权益名称
      // };
      if (e == 1) {
        if (this.formStepFirst.scope == "0") {
          this.phoneList[
            this.choseBtnIndex
          ].teamServiceName = this.rightServiceObj.rightService;
          this.phoneList[
            this.choseBtnIndex
          ].teamServiceId = this.rightServiceObj.rightServiceId;
          this.phoneList[
            this.choseBtnIndex
          ].doctorSchemeId = this.rightServiceObj.doctorSchemeId;
          this.phoneList[
            this.choseBtnIndex
          ].doctorTeamId = this.rightServiceObj.doctorTeamId;
          this.phoneList[
            this.choseBtnIndex
          ].experiencePack = this.rightServiceObj.experiencePack;
        }
      }
      if (e != 4) {
        this.phoneList[this.choseBtnIndex].goods = [];
        this.phoneList[this.choseBtnIndex].teamServices = [];
      }
      if (e == 1 || e == 4) {
        if (this.formStepFirst.scope == 2) {
          //仅外链
          this.getTeamServicePageRequest();
        } else {
          //仅疗管 应用全部
          this.therapistByDiseaseIdRequest();
        }
      }
      this.$nextTick(() => {
        this.$refs["formStepSecond"].clearValidate("freeForm");
        this.$refs["formStepSecond"].clearValidate("buttonBindForm");
        this.$refs["formStepSecond"].clearValidate("smallApp");
        this.$refs["formStepSecond"].clearValidate("styleType");
        this.$refs["formStepSecond"].clearValidate("btnImageUrl");
        this.$refs["formStepSecond"].clearValidate("channelId");
      });

      this.$forceUpdate();
    },
    wechatChange(e) {
      //小程序
      this.phoneList[this.index].appId = e;
    },
    pageInput(e) {
      //跳转页面链接
      this.phoneList[this.index].jumpUrl = e;
    },
    showFrom(arr) {
      let showArr = arr.split(",");
      this.phoneList.forEach(element => {
        if (showArr.indexOf(element.id) > -1) {
          element.flag = element.formType;
        }
      });
    },
    formChange(e) {
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[
        this.choseBtnIndex
      ].evocativeForm = this.formStepSecond.evocativeForm;
      if (this.phoneList[this.choseBtnIndex].bindForm) {
        this.phoneList[this.choseBtnIndex].arrForm = this.phoneList[
          this.choseBtnIndex
        ].bindForm.split(",");
      }
      if (e == "1") {
        this.formStepSecond.buttonBindForm = this.phoneList[this.choseBtnIndex]
          .buttonBindForm
          ? this.phoneList[this.choseBtnIndex].buttonBindForm
          : [];

        this.formBtnFlag = true;
        this.$forceUpdate();
      } else {
        if (
          this.phoneList[this.choseBtnIndex].bindForm &&
          this.phoneList[this.choseBtnIndex].bindForm != ""
        ) {
          let showArr = this.phoneList[this.choseBtnIndex].bindForm.split(",");
          this.phoneList[this.choseBtnIndex].bindFormID = this.phoneList[
            this.choseBtnIndex
          ].bindForm;
          this.phoneList[
            this.choseBtnIndex
          ].buttonBindForm = this.formStepSecond.buttonBindForm;
          this.phoneList[this.choseBtnIndex].bindForm = "";
          this.phoneList.forEach(element => {
            if (showArr.indexOf(element.id) > -1) {
              element.flag = 0;
              element.whetherBindFrom = 0;
            }
          });
        }
        this.phoneList[this.choseBtnIndex].arrForm = [];
        this.phoneList[this.choseBtnIndex].bindForm = "";
      }
      this.formStepSecond.buttonBindForm = [];
      this.screenFrom();
      this.$forceUpdate();
      this.formButtonTypeFun();
      // this.phoneList[this.index].evocativeForm = e.toString();
    },
    hoverButtonChange(e) {
      //选择悬停按钮的change事件
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });

      if (this.phoneList[this.choseBtnIndex].styleType == 2) {
        if (this.imgHeight > 406) {
          this.$message.error("上传的按钮图片高度不能超过406px");
        }
      }

      let hoverButtonNum = this.phoneList.filter(item => {
        return item.isButtonHover == true && item.type == 4;
      });
      if (e && hoverButtonNum.length > 1) {
        this.$message.error("当前落地页悬停按钮数量超出2个，请重新编辑");
        this.phoneList[this.choseBtnIndex].isButtonHover = false;
        this.formStepSecond.isButtonHover = false;
      } else {
        this.phoneList[this.choseBtnIndex].isButtonHover = e;
        this.formStepSecond.isButtonHover = e;
      }
      hoverButtonNum = this.phoneList.filter(item => {
        return item.isButtonHover == true && item.type == 4;
      });
      if (this.formStepSecond.isButtonHover) {
        this.resetBtnFun();
        if (hoverButtonNum.length > 1) {
          this.phoneList[this.choseBtnIndex].buttonHoverSort = 2;
        }
      } else {
        if (hoverButtonNum.length == 1) {
          this.resetBtnFun();
        }
      }
      this.$forceUpdate();
    },
    FilterDataFree(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      var c = b;
      for (var i = 0; i < a.length; i++) {
        if (c.indexOf(a[i].id) < 0) {
          result.push(a[i]);
        }
      }
      return result;
    },
    determineClick1() {
      //表单确定1
      let newArr = this.formMessageListAll.filter(v =>
        this.formStepSecond.freeForm.every(val => val.diseaseId != v.diseaseId)
      );
      this.formMessageList2 = newArr;

      this.$forceUpdate();
      this.value11List = [];
      this.formButtonTypeList = this.formStepSecond.freeForm;

      this.phoneList.forEach(element => {
        if (element.type == 3 && !element.bind) {
          element.flag = 0;
          element.whetherBindFrom = 0;
        }
      });
      if (this.formStepSecond.freeForm.length <= 0) {
        this.phoneList.forEach(element => {
          if (element.type == 3 && !element.bind) {
            element.flag = 0;
            element.whetherBindFrom = 0;
          }
        });
        // whetherBindFrom
      } else {
        this.formStepSecond.freeForm.forEach((item, index) => {
          if (item.diseaseId == "1") {
            let obj1 = {
              type: 3,
              formType: 1,
              sort: 3,
              flag: 1,
              flagType: 1,
              dragFlag1: true,
              fromAllType: true,
              id: this.idFun()
            };
            this.value11List.push(obj1);
          }
          if (item.diseaseId == "2") {
            let obj2 = {
              type: 3,
              formType: 2,
              sort: 3,
              flag: 2,
              flagType: 2,
              dragFlag2: true,
              fromAllType: true,
              id: this.idFun()
            };
            this.value11List.push(obj2);
          }
          if (item.diseaseId == "3") {
            let obj3 = {
              type: 3,
              formType: 3,
              sort: 3,
              flag: 3,
              flagType: 3,
              dragFlag3: true,
              fromAllType: true,
              id: this.idFun()
            };
            this.value11List.push(obj3);
          }
        });
        this.phoneList = this.phoneList.concat(this.value11List);
      }
    },
    cancelClick() {
      // this.formStepSecond.buttonBindForm = [];
    },
    FilterDataNo(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      var c = b;
      for (var i = 0; i < a.length; i++) {
        if (c.indexOf(a[i].id) < 0) {
          result.push(a[i]);
        }
      }
      return result;
    },
    idFun() {
      //自己建id
      let date = new Date().valueOf();
      let num = parseInt(1000000 * Math.random());
      let strId = date.toString() + num.toString();
      return strId;
    },
    // determineClick2() {
    confirmClick() {
      //表单确定2
      if (this.formStepSecond.evocativeForm != "1") {
        return false;
      }
      let objFirst = {
        type: 3,
        formType: 1,
        sort: 3,
        flag: 1,
        flagType: 1,
        dragFlag1: true,
        bind: true,
        id: this.idFun()
      };

      let objSecond = {
        type: 3,
        formType: 2,
        sort: 3,
        flag: 2,
        flagType: 2,
        dragFlag2: true,
        bind: true,
        id: this.idFun()
      };

      let objThird = {
        type: 3,
        formType: 3,
        sort: 3,
        flag: 3,
        flagType: 3,
        dragFla3: true,
        bind: true,
        id: this.idFun()
      };
      this.phoneList[this.choseBtnIndex].buttonBindForm = [];
      // this.phoneList[this.choseBtnIndex].bindForm = this.phoneList[
      //   this.choseBtnIndex
      // ].bindFormID;
      if (this.phoneList[this.choseBtnIndex].bindForm) {
        this.phoneList[this.choseBtnIndex].bindForm = "";
        let newPhoneList = this.FilterDataNo(
          this.phoneList,
          this.phoneList[this.choseBtnIndex].arrForm
        );
        this.phoneList = newPhoneList;
        this.choseBtnIndex = this.phoneList.findIndex(item => {
          return item.id == this.selectBtnArea.id;
        });

        this.phoneList[this.choseBtnIndex].arrForm = [];
        let btnForm = [];
        let bindFormStr = [];

        for (let i = 0; i < this.formStepSecond.buttonBindForm.length; i++) {
          if (this.formStepSecond.buttonBindForm[i].diseaseId == 1) {
            btnForm.push(objFirst);
            bindFormStr.push(objFirst.id);
          }
          if (this.formStepSecond.buttonBindForm[i].diseaseId == 2) {
            btnForm.push(objSecond);
            bindFormStr.push(objSecond.id);
          }
          if (this.formStepSecond.buttonBindForm[i].diseaseId == 3) {
            btnForm.push(objThird);
            bindFormStr.push(objThird.id);
          }
        }
        this.phoneList[this.choseBtnIndex].bindForm = bindFormStr.toString();
        this.phoneList[this.choseBtnIndex].arrForm = bindFormStr;
        this.phoneList.splice(this.choseBtnIndex, 0, ...btnForm);
        //新加20221125
        this.choseBtnIndex = this.phoneList.findIndex(item => {
          return item.id == this.selectBtnArea.id;
        });
        //新加20221125
        this.formButtonTypeFun();
      } else {
        if (this.phoneList[this.choseBtnIndex].bindForm) {
          this.phoneList[this.choseBtnIndex].bindForm = "";
        }
        let btnForm = [];
        let bindFormStr = [];
        this.formStepSecond.buttonBindForm.forEach(v => {
          if (v.diseaseId == 1) {
            btnForm.push(objFirst);
            bindFormStr.push(objFirst.id);
          }
          if (v.diseaseId == 2) {
            btnForm.push(objSecond);
            bindFormStr.push(objSecond.id);
          }
          if (v.diseaseId == 3) {
            btnForm.push(objThird);
            bindFormStr.push(objThird.id);
          }
        });
        this.phoneList[this.choseBtnIndex].arrForm = [];
        this.phoneList[this.choseBtnIndex].bindForm = bindFormStr.toString();
        // this.phoneList.splice(this.choseBtnIndex, 0, ...btnForm);
        this.phoneList.splice(this.choseBtnIndex, 0, ...btnForm);
        let choseBtnIndex = this.phoneList.findIndex(item => {
          return item.id == this.selectBtnArea.id;
        });
        this.phoneList[choseBtnIndex].arrForm = this.phoneList[
          choseBtnIndex
        ].bindForm.split(",");

        this.selectBtnArea.bindForm = btnForm.map(v => v.id).join(",");
        this.choseBtnIndex = this.phoneList.findIndex(item => {
          return item.id == this.selectBtnArea.id;
        });

        this.formButtonTypeFun();
      }

      // this.formStepSecond.freeForm = [];
      // this.formButtonTypeList = [];
      // let arrForm = this.phoneList.filter(item => {
      //   return !item.bind && item.type == 3;
      // });
      // let arrId = [];
      // if (arrForm.length > 0) {
      //   for (let i = 0; i < arrForm.length; i++) {
      //     arrId.push(arrForm[i].id);
      //   }
      // }
      // let newPhoneList = this.FilterDataFree(this.phoneList, arrId);
      // this.phoneList = newPhoneList;
      this.screenFrom();
      this.formBtnFlag = false;
    },
    formMessageChange(e) {
      // let newArr = this.formMessageListAll.filter(v =>
      //   e.every(val => val.diseaseId != v.diseaseId)
      // );
      // this.formMessageList2 = newArr;
    },
    platFromChange(e) {
      //按钮的表单内容
      // let newArr = this.formMessageListAll.filter(v =>
      //   e.every(val => val.diseaseId != v.diseaseId)
      // );
      // this.formMessageList1 = newArr;
      this.screenFrom();
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.formBtnFlag = true;
    },
    platFromBloneChange(e) {
      //切换归属的时候清空服务和病种start
      this.$set(this.formStepFirst, "diseaseId", "");
      // this.formStepSecond.rightService = ""; //服务权益
      // this.formStepSecond.rightServiceId = ""; //服务权益id
      // this.formStepSecond.interestName = ""; //服务权益名称
      // this.phoneList.forEach((item, indedx) => {
      //   if (item.type == 4) {
      //     item.teamServiceId = null;
      //     item.teamServiceName = null;
      //   }
      // });
      if (e == "0") {
        this.formStepFirst.scope = 0;
        this.termListDataRequest();
        this.formStepFirst.hospitalId = null;
        this.formStepFirst.doctorTeamId = null;
        // 新加20221129 start
        this.scope1 = false;
        this.scope2 = false;
        this.formStepFirst.scope = 0;
        // 新加20221129 end
      } else {
        this.formStepFirst.scope = null;
        this.diseaseList = [];
        this.formStepFirst.hospitalId = null;
        this.formStepFirst.doctorTeamId = null;
        this.diseaseListBlone = [];
      }
    },
    submitHandel(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          pagelandSave({ ...this.formStepFirst, id: this.id }).then(res => {
            if (res.code == 0) {
              this.id = res.data;
              this.step = "second";
              this.$message.success("保存成功");
            }
          });
        } else {
          return false;
        }
      });
    },
    prevClick() {
      this.step = "first";
      this.btnFlag = false;
      // this.phoneList.forEach((item, indedx) => {
      //   if (item.type == 3 && item.bind) {
      //     item.flag = 0;
      //   }
      // });
      this.listUsedDiseaseTypeRequest().then(res => {
        this.pagelandDetailRequest();
      });
      // 点击上一步清空选择的服务权益，否则点击再点击下一步，服务权益会匹配已选择
      // this.formStepSecond.rightServiceRules = "";
      // this.formStepSecond.rightService = "";
      // this.formStepSecond.rightServiceId = "";
    },
    arrfilterFun(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      for (var i = 0; i < b.length; i++) {
        for (var j = 0; j < a.length; j++) {
          if (a[j].id != b[i]) {
            result.push(b[i]);
          }
        }
      }
      return result.toString();
    },
    saveClick(formName) {
      let arrBtn = this.phoneList.filter(item => {
        return item.type == 4;
      });
      if (arrBtn.length <= 0) {
        this.$message.error("请绑定按钮");
        return false;
      }

      if (
        this.formStepSecond.buttonType == 2 &&
        this.formStepSecond.buttonBindForm.length <= 0
      ) {
        this.formStepSecond.evocativeForm = 2;
      }

      this.$forceUpdate();
      this.$refs[formName].validate(valid => {
        if (valid) {
          let arrBtn1 = this.phoneList.filter(item => {
            return item.type == 4;
          });
          let arrBtn2 = this.phoneList.filter(item => {
            return item.type == 3 && !item.bind && item.whetherBindFrom != 0;
          });
          let flagBtn = true;
          if (arrBtn1.length > 0) {
            let num = 0;
            let buttonNum = 0;
            arrBtn1.forEach((item, index) => {
              if (item.bindForm && item.bindForm != "") {
                num++;
                // flagBtn = false;
              }
              if (item.buttonType == 1 && item.bindForm == "") {
                buttonNum++;
              }
              if (item.buttonType == 4 && item.bindForm == "") {
                buttonNum++;
              }
            });
            if (buttonNum > 0) {
              //有一个领权益的按钮
              if (arrBtn2.length <= 0) {
                //判断是否绑定了游离表单
                flagBtn = true;
              } else {
                flagBtn = false;
              }
            } else {
              // //没有领权益的按钮
              flagBtn = false;
            }
          } else {
            if (arrBtn2.length <= 0) {
              flagBtn = true;
            }
          }

          let arrShop = this.phoneList.filter(item => {
            return item.type == 4 && item.buttonType == 4;
          });
          if (arrShop.length > 0) {
            if (arrShop[0].teamServices.length <= 0) {
              flagBtn = false;
            }
          }
          if (arrShop.length > 0 && this.formStepFirst.scope != 2) {
            this.$message.error(
              `${arrShop[0].text}按钮类型商品服务，请删除该按钮后发布或者保存`
            );
            return false;
          }

          // if (flagBtn) {
          //   this.$message.error("请绑定游离表单");
          //   return false;
          // }

          let isRequireUpload = false;
          this.phoneList.forEach((item, index) => {
            if (this.formStepSecond.isAddRequire != 1) {
              if (item.isRequireUpload == 1) {
                isRequireUpload = true;
              }
            }
          });
          if (isRequireUpload) {
            this.$message.error("请修改按钮图片的是否必传项");
            return false;
          }

          if (
            this.formStepSecond.isAddRequire == 1 &&
            this.formStepSecond.leastNum > 30
          ) {
            this.$message.error("添加的图片不能超过30张");
            return false;
          }
          if (
            arrShop.length > 0 &&
            arrShop[0].goods.length <= 0 &&
            arrShop[0].teamServices.length <= 0
          ) {
            this.$message.error("请至少选择一个服务或一个商品");
            return false;
          }

          let phoneList1 = this.phoneList.filter(
            item => item.whetherBindFrom != 0
          );
          let phoneList2 = phoneList1.map((item, index) => {
            return {
              ...item,
              sort: index + 1
            };
          });
          phoneList2.forEach((item, index) => {
            if (item.type == 4) {
              if (item.bindForm) {
                item.bindForm = this.noRepeatArr(item.bindForm.split(","));
              }
              if (item.buttonType == 1) {
                if (
                  this.formStepFirst.belong == "0" &&
                  (this.formStepFirst.scope == "0" ||
                    this.formStepFirst.scope == "2")
                ) {
                  item.teamServiceId = this.rightServiceObj.rightServiceId;
                  item.teamServiceName = this.rightServiceObj.rightService;
                  item.doctorSchemeId = this.rightServiceObj.doctorSchemeId;
                  item.doctorTeamId = this.rightServiceObj.doctorTeamId;
                  item.experiencePack = this.rightServiceObj.experiencePack;
                } else {
                  item.teamServiceId = null;
                  item.teamServiceName = null;
                }
              }
              // if (
              //   this.formStepFirst.belong == "0" &&
              //   (this.formStepFirst.scope == "0" ||
              //     this.formStepFirst.scope == "2")
              // ) {
              //   item.teamServiceId = this.rightServiceObj.rightServiceId;
              //   item.teamServiceName = this.rightServiceObj.rightService;
              // } else {
              //   item.teamServiceId = null;
              //   item.teamServiceName = null;
              // }
            }
          });

          let obj = {
            id: this.id,
            content: phoneList2,
            backgroundImageUrl: this.formStepSecond.backgroundImageUrl
          };
          let landpage = true;
          phoneList2.forEach((item, index) => {
            if (item.goods && item.goods.length > 0) {
              item.goods.forEach((el, elIndex) => {
                if (el.goodsState == 1) {
                  landpage = false;
                }
              });
            }
          });

          if (landpage) {
            pagelandSaveContent(obj).then(res => {
              if (res.code == 0) {
                this.btnFlagServer = true;
                this.$message.success("保存成功");
              }
            });
          } else {
            this.$confirm(
              "当前列表内有商品已经下架，是否继续保存/发布？",
              "确认信息",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                customClass: "message-confirm-style"
              }
            )
              .then(() => {
                pagelandSaveContent(obj).then(res => {
                  if (res.code == 0) {
                    this.btnFlagServer = true;
                    this.$message.success("保存成功");
                  }
                });
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    noRepeatArr(arr) {
      var newArr = [];
      var myset = new Set(arr); //利用了Set结构不能接收重复数据的特点
      for (var val of myset) {
        newArr.push(val);
      }
      return newArr.toString();
    },
    releaseClick(formName) {
      // this.$refs[formName].clearValidate();
      // this.saveClick(formName);
      let arrBtn = this.phoneList.filter(item => {
        return item.type == 4;
      });
      if (arrBtn.length <= 0) {
        this.$message.error("请绑定按钮");
        return false;
      }
      // formButtonTypeFlag = arrBtn.some(item => {
      //   return item.evocativeForm == "1";
      // });
      let arrFlag0 = this.phoneList.filter(item => {
        return item.flag == 0;
      });
      if (arrFlag0.length > 0) {
        // this.phoneList.forEach((item, index) => {
        //   if (item.type == 4) {
        //     if (item.bindForm && item.bindForm != "") {
        //       let arr1 = item.bindForm && item.bindForm.split(",");
        //       item.bindForm = this.arrfilterFun(arrFlag0, arr1);
        //     }
        //   }
        // });
      }
      let flagBtn = false;
      let formButtonTypeFlag = true;
      if (arrBtn.length <= 1) {
        if (
          this.formStepSecond.evocativeForm == "2" &&
          this.formButtonTypeList.length <= 0
        ) {
          flagBtn = true;
        }
      } else {
        formButtonTypeFlag = arrBtn.some(item => {
          return item.evocativeForm == "1";
        });
        if (!formButtonTypeFlag && this.formButtonTypeList.length <= 0) {
          flagBtn = true;
        }
      }
      if (
        this.formStepSecond.buttonType == 2 &&
        this.formStepSecond.buttonBindForm.length <= 0
      ) {
        this.formStepSecond.evocativeForm = 2;
      }
      this.$forceUpdate();
      this.$refs[formName].validate(valid => {
        if (valid) {
          let arrBtn1 = this.phoneList.filter(item => {
            return item.type == 4;
          });
          let arrBtn2 = this.phoneList.filter(item => {
            return item.type == 3 && !item.bind && item.whetherBindFrom != 0;
          });
          let flagBtn = true;
          if (arrBtn1.length > 0) {
            let num = 0;
            let buttonNum = 0;
            arrBtn1.forEach((item, index) => {
              if (item.bindForm && item.bindForm != "") {
                num++;
                // flagBtn = false;
              }
              if (item.buttonType == 1 && item.bindForm == "") {
                buttonNum++;
              }
              if (item.buttonType == 4 && item.bindForm == "") {
                buttonNum++;
              }
            });
            if (buttonNum > 0) {
              //有一个领权益的按钮
              if (arrBtn2.length <= 0) {
                //判断是否绑定了游离表单
                flagBtn = true;
              } else {
                flagBtn = false;
              }
            } else {
              // //没有领权益的按钮
              flagBtn = false;
            }
          } else {
            if (arrBtn2.length <= 0) {
              flagBtn = true;
            }
          }

          let arrShop = this.phoneList.filter(item => {
            return item.type == 4 && item.buttonType == 4;
          });
          if (arrShop.length > 0) {
            if (arrShop[0].teamServices.length <= 0) {
              flagBtn = false;
            }
          }
          if (arrShop.length > 0 && this.formStepFirst.scope != 2) {
            this.$message.error(
              `${arrShop[0].text}按钮类型伟商品服务，请删除该按钮后发布或者保存`
            );
            return false;
          }

          // if (flagBtn) {
          //   this.$message.error("请绑定游离表单");
          //   return false;
          // }

          let isRequireUpload = false;
          this.phoneList.forEach((item, index) => {
            if (this.formStepSecond.isAddRequire != 1) {
              if (item.isRequireUpload == 1) {
                isRequireUpload = true;
              }
            }
          });
          if (isRequireUpload) {
            this.$message.error("请修改按钮图片的是否必传项");
            return false;
          }

          if (
            this.formStepSecond.isAddRequire == 1 &&
            this.formStepSecond.leastNum > 30
          ) {
            this.$message.error("添加的图片不能超过30张");
            return false;
          }
          if (
            arrShop.length > 0 &&
            arrShop[0].goods.length <= 0 &&
            arrShop[0].teamServices.length <= 0
          ) {
            this.$message.error("请至少选择一个服务或一个商品");
            return false;
          }

          let phoneList1 = this.phoneList.filter(
            item => item.whetherBindFrom != 0
          );
          let phoneList2 = phoneList1.map((item, index) => {
            return {
              ...item,
              sort: index + 1
            };
          });
          phoneList2.forEach((item, index) => {
            if (item.type == 4) {
              if (item.bindForm) {
                item.bindForm = this.noRepeatArr(item.bindForm.split(","));
              }
              if (item.buttonType == 1) {
                if (
                  this.formStepFirst.belong == "0" &&
                  (this.formStepFirst.scope == "0" ||
                    this.formStepFirst.scope == "2")
                ) {
                  item.teamServiceId = this.rightServiceObj.rightServiceId;
                  item.teamServiceName = this.rightServiceObj.rightService;
                  item.doctorSchemeId = this.rightServiceObj.doctorSchemeId;
                  item.doctorTeamId = this.rightServiceObj.doctorTeamId;
                  item.experiencePack = this.rightServiceObj.experiencePack;
                } else {
                  item.teamServiceId = null;
                  item.teamServiceName = null;
                }
              }
            }
          });
          let obj = {
            id: this.id,
            content: phoneList2,
            backgroundImageUrl: this.formStepSecond.backgroundImageUrl
          };
          let landpage = true;
          phoneList2.forEach((item, index) => {
            if (item.goods && item.goods.length > 0) {
              item.goods.forEach((el, elIndex) => {
                if (el.goodsState == 1) {
                  landpage = false;
                }
              });
            }
          });

          if (landpage) {
            pagelandSaveContent(obj).then(res => {
              if (res.code == 0) {
                publish({
                  isPublish: true,
                  landingPageId: this.id
                }).then(res => {
                  if (res.code == 0) {
                    this.$router.push({
                      path: "/operationPromote/landPageList"
                    });
                    this.$message.success("发布成功");
                  }
                });
              }
            });
          } else {
            this.$confirm(
              "当前列表内有商品已经下架，是否继续保存/发布？",
              "确认信息",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                customClass: "message-confirm-style"
              }
            )
              .then(() => {
                pagelandSaveContent(obj).then(res => {
                  if (res.code == 0) {
                    publish({
                      isPublish: true,
                      landingPageId: this.id
                    }).then(res => {
                      if (res.code == 0) {
                        this.$router.push({
                          path: "/operationPromote/landPageList"
                        });
                        this.$message.success("发布成功");
                      }
                    });
                  }
                });
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    startDrag() {},
    endDrag() {},
    onMove(e, originalEvent) {
      if (
        e.relatedContext.element.dragFlag1 == false ||
        e.relatedContext.element.dragFlag2 == false ||
        e.relatedContext.element.dragFlag3 == false ||
        e.relatedContext.element.dragFlag4 == false
      )
        return false;
    },
    getWechatType() {
      wechatType({ type: 1 }).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.length) {
            this.wechatList = res.data;
          } else {
            this.wechatList = [];
          }
        }
      });
    },
    beforeRemovePic(file, fileList, index) {
      // return;
      let indexs = this.phoneList.findIndex(item => {
        return item.url == this.formStepSecond.contentConfigImageUrl[index];
      });
      this.formStepSecond.contentConfigImageUrl.splice(index, 1);
      this.phoneList.splice(indexs, 1);
    },
    // beforeRemovePicBtn(file, fileList, index) {
    // return;
    // let indexs = this.phoneList.findIndex(item => {
    //   return item.url == this.formStepSecond.contentConfigImageUrl[index];
    // });
    // this.formStepSecond.contentConfigImageUrl.splice(index, 1);
    // this.formStepSecond.btnImageUrl = null;
    // this.phoneList.splice(indexs, 1);
    // },
    bigImgFun(file, width, height) {
      //验证图片宽高
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        let that = this;
        image.onload = function() {
          let isSize = image.width == width && image.height == height;
          resolve(isSize);
          if (!isSize) {
            that.$message.error("上传头像图片尺寸为${width}*${height}");
          }
          return isSize;
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    handleIntroChange(response, file) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
        this.formStepSecond.contentConfigImageUrl.push(url);
        let obj = {
          type: 1,
          url: url,
          sort: 1,
          id: this.idFun()
        };
        this.phoneList.push(obj);
      }
    },

    async handleAvatarSuccess(res, file) {
      const isLt2M = file.raw.size / 1024 / 1024 < 200;
      const rule = /\.(swf|avi|flv|mpg|rm|mov|asf|3gp|mkv|rmvb|mp4)$/;
      if (file.raw.name.match(rule) == null) {
        return false;
      }

      if (!isLt2M) {
        return false;
      }
      if (this.formStepSecond.videoList.length > 4) {
        return false;
      }

      let resTime = await this.timeFun(file.raw);

      let time = 0;
      time = resTime;
      if (time > 300) {
        this.formDataLoading = false;
        return false;
      }

      if (this.videoValidation) {
        //通过视频验证
        this.formStepSecond.videoList.push(this.imgBaseURL + res.data);
        this.formDataLoading = false;
        let obj = {
          type: 2,
          url: this.imgBaseURL + res.data,
          sort: 2,
          id: this.idFun()
        };
        this.phoneList.push(obj);
      }
    },
    timeFun(file) {
      return new Promise((resolve, reject) => {
        var binaryData = [];
        // 传入file
        binaryData.push(file);
        //获取视频或者音频时长
        var fileurl = URL.createObjectURL(
          new Blob(binaryData, { type: "application/zip" })
        );
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(fileurl);
        var duration;
        audioElement.addEventListener("loadedmetadata", function(_event) {
          duration = audioElement.duration;
          resolve(duration);
        });
      });
    },
    async beforeAvatarUpload(file) {
      this.videoValidation = true;
      return new Promise(async (resolve, reject) => {
        const isLt2M = file.size / 1024 / 1024 < 200;
        const rule = /\.(swf|avi|flv|mpg|rm|mov|asf|3gp|mkv|rmvb|mp4)$/;
        if (file.name.match(rule) == null) {
          this.$message.error("上传只能是视频格式!");
          this.videoValidation = false;
          return reject();
        }

        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 200MB!");
          this.videoValidation = false;
          return reject();
          return false;
        }
        if (this.formStepSecond.videoList.length > 4) {
          this.videoValidation = false;
          return reject();
        }

        let resTime = await this.timeFun(file);

        let time = 0;
        time = resTime;
        this.formDataLoading = true;
        if (time > 300) {
          this.$message.error("视频时长不超过五分钟!");
          this.formDataLoading = false;
          this.videoValidation = false;
          return reject();
          // return false;
        }
        resolve();
      });
    },
    // teamServices
    assessmentSend(index, row) {
      if (this.formStepFirst.scope == 2 && this.suborderCode == 0) {
        if (this.formStepSecond.buttonType == 1) {
          if (this.teamServiceNameList.length <= 0) {
            //只有仅外链的通用病种 才是多选的
            let objService = {
              diseaseId: row.diseaseTypeId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            };
            this.tableData[index].flag = false;
            this.teamServiceNameList.push(objService);
            // this.phoneList[this.index].teamServiceList.push(objService);
            this.phoneList[
              this.index
            ].teamServiceList = this.teamServiceNameList;
            this.phoneList[this.index].teamServiceId = "";
            this.phoneList[this.index].teamServiceName = "";
            this.formStepSecond.rightService = objService.name;
            this.formStepSecond.rightServiceRules = objService.name;
            this.$message.success("服务添加成功");
          } else {
            let arr = this.teamServiceNameList.filter(item => {
              return row.diseaseTypeId == item.diseaseId;
            });
            if (arr.length <= 0) {
              //只有仅外链的通用病种 才是多选的
              let objService = {
                diseaseId: row.diseaseTypeId,
                id: row.id,
                name: row.name,
                schemeType: row.schemeType,
                doctorSchemeId: row.doctorSchemeId,
                doctorTeamId: row.doctorTeamId,
                experiencePack: row.experiencePack
              };
              this.tableData[index].flag = false;
              this.teamServiceNameList.push(objService);
              // this.phoneList[this.index].teamServiceList.push(objService);
              this.phoneList[
                this.index
              ].teamServiceList = this.teamServiceNameList;
              this.phoneList[this.index].teamServiceId = "";
              this.phoneList[this.index].teamServiceName = "";
              this.$message.success("服务添加成功");
              if (this.teamServiceNameList.length > 0) {
                this.formStepSecond.rightService = row.name;
                this.formStepSecond.rightServiceRules = row.name;
              }
            } else {
              this.$message.error("已添加同病种体验服务，请不要重复添加");
            }
          }
        } else if (this.formStepSecond.buttonType == 4) {
          if (this.teamServices.length <= 0) {
            //只有仅外链的通用病种 才是多选的
            let objService = {
              diseaseId: row.diseaseTypeId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            };
            this.tableData[index].flag = false;
            this.teamServices.push(objService);
            // this.phoneList[this.index].teamServiceList.push(objService);
            this.phoneList[this.index].teamServices = this.teamServices;
            this.$message.success("服务添加成功");
          } else {
            let arr = this.teamServices.filter(item => {
              return row.diseaseTypeId == item.diseaseId;
            });
            if (arr.length <= 0) {
              //只有仅外链的通用病种 才是多选的
              let objService = {
                diseaseId: row.diseaseTypeId,
                id: row.id,
                name: row.name,
                schemeType: row.schemeType,
                doctorSchemeId: row.doctorSchemeId,
                doctorTeamId: row.doctorTeamId,
                experiencePack: row.experiencePack
              };
              this.tableData[index].flag = false;
              this.teamServices.push(objService);
              // this.phoneList[this.index].teamServiceList.push(objService);
              this.phoneList[this.index].teamServices = this.teamServices;
              this.$message.success("服务添加成功");
            } else {
              this.$message.error("已添加同病种体验服务，请不要重复添加");
            }
          }
        }
      } else {
        this.initializationFun();
        if (this.formStepSecond.buttonType == 1) {
          this.interestName = row.name;
          let objService = [
            {
              diseaseId: this.formStepFirst.diseaseId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            }
          ];
          this.tableData[index].flag = false;
          this.teamServiceNameList = objService;
          this.phoneList[this.index].teamServiceId = row.id;
          this.phoneList[this.index].teamServiceName = row.name;
          this.phoneList[this.index].teamServiceList = [];
          this.rightServiceObj = {
            //用来切换归属和应用范围清空之后再赋值
            rightService: row.name, //服务权益
            rightServiceId: row.id, //服务权益id
            interestName: row.name, //服务权益名称
            schemeType: row.schemeType,
            doctorSchemeId: row.doctorSchemeId,
            doctorTeamId: row.doctorTeamId,
            experiencePack: row.experiencePack
          };
          this.tableData[index].flag = false;
          this.formStepSecond.rightService = row.name;
          this.formStepSecond.rightServiceId = row.id;
          this.formStepSecond.rightServiceRules = row.name;
          this.$message.success("服务添加成功");
          this.showAddQuestion = false;
        } else if (this.formStepSecond.buttonType == 4) {
          let objService = [
            {
              diseaseId: row.diseaseTypeId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            }
          ];
          this.tableData[index].flag = false;
          this.teamServices = objService;
          this.phoneList[this.index].teamServices = this.teamServices;
          this.$message.success("服务添加成功");
          this.showAddQuestion = false;
        }
      }
    },
    assessmentSendDoctor(index, row) {
      if (this.formStepFirst.scope == 2 && this.suborderCode == 0) {
        //只有仅外链的通用病种 才是多选的

        if (this.formStepSecond.buttonType == 1) {
          if (this.teamServiceNameList.length <= 0) {
            //只有仅外链的通用病种 才是多选的
            let objService = {
              diseaseId: row.diseaseTypeId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            };
            this.tableDataDoctor[index].flag = false;
            this.teamServiceNameList.push(objService);
            this.formStepSecond.rightServiceRules = row.name;
            // this.phoneList[this.index].teamServiceList.push(objService);
            this.phoneList[
              this.index
            ].teamServiceList = this.teamServiceNameList;
            this.phoneList[this.index].teamServiceId = "";
            this.phoneList[this.index].teamServiceName = "";
            this.$message.success("服务添加成功");
            if (this.teamServiceNameList.length > 0) {
              this.formStepSecond.rightService = row.name;
              this.formStepSecond.rightServiceRules = row.name;
            }
          } else {
            let arr = this.teamServiceNameList.filter(item => {
              return row.diseaseTypeId == item.diseaseId;
            });
            if (arr.length <= 0) {
              //只有仅外链的通用病种 才是多选的
              let objService = {
                diseaseId: row.diseaseTypeId,
                id: row.id,
                name: row.name,
                schemeType: row.schemeType,
                doctorSchemeId: row.doctorSchemeId,
                doctorTeamId: row.doctorTeamId,
                experiencePack: row.experiencePack
              };
              this.tableDataDoctor[index].flag = false;
              this.teamServiceNameList.push(objService);
              this.formStepSecond.rightServiceRules = row.name;
              // this.phoneList[this.index].teamServiceList.push(objService);
              this.phoneList[
                this.index
              ].teamServiceList = this.teamServiceNameList;
              this.phoneList[this.index].teamServiceId = "";
              this.phoneList[this.index].teamServiceName = "";
              this.$message.success("服务添加成功");
              if (this.teamServiceNameList.length > 0) {
                this.formStepSecond.rightService = row.name;
                this.formStepSecond.rightServiceRules = row.name;
              }
            } else {
              this.$message.error("已添加同病种体验服务，请不要重复添加");
            }
          }
        } else if (this.formStepSecond.buttonType == 4) {
          if (this.teamServices.length <= 0) {
            //只有仅外链的通用病种 才是多选的
            let objService = {
              diseaseId: row.diseaseTypeId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            };
            this.tableDataDoctor[index].flag = false;
            this.teamServices.push(objService);

            this.phoneList[this.index].teamServices = this.teamServices;
            this.$message.success("服务添加成功");
          } else {
            
            let arr = this.teamServices.filter(item => {
              return row.diseaseTypeId == item.diseaseId;
            });
            if (arr.length <= 0) {
              //只有仅外链的通用病种 才是多选的
              let objService = {
                diseaseId: row.diseaseTypeId,
                id: row.id,
                name: row.name,
                schemeType: row.schemeType,
                doctorSchemeId: row.doctorSchemeId,
                doctorTeamId: row.doctorTeamId,
                experiencePack: row.experiencePack
              };
              this.tableDataDoctor[index].flag = false;
              this.teamServices.push(objService);
              this.phoneList[this.index].teamServices = this.teamServices;
              this.$message.success("服务添加成功");
            } else {
              this.$message.error("已添加同病种体验服务，请不要重复添加");
            }
          }
        }
      } else {
        // this.initializationFun();
        this.interestName = row.name;

        if (this.formStepSecond.buttonType == 1) {
          this.formStepSecond.rightService = row.name;
          this.formStepSecond.rightServiceId = row.id;
          this.formStepSecond.rightServiceRules = row.name;
          let objService = [
            {
              diseaseId: this.formStepFirst.diseaseId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            }
          ];
          this.tableDataDoctor[index].flag = false;
          this.teamServiceNameList = objService;
          this.phoneList[this.index].teamServiceId = row.id;
          this.phoneList[this.index].teamServiceName = row.name;
          this.phoneList[this.index].teamServiceList = [];
          this.rightServiceObj = {
            //用来切换归属和应用范围清空之后再赋值
            rightService: row.name, //服务权益
            rightServiceId: row.id, //服务权益id
            interestName: row.name, //服务权益名称
            doctorSchemeId: row.doctorSchemeId,
            doctorTeamId: row.doctorTeamId,
            experiencePack: row.experiencePack
          };
          this.$message.success("服务添加成功");
          this.showAddQuestion = false;
        } else if (this.formStepSecond.buttonType == 4) {
          let objService = [
            {
              diseaseId: this.formStepFirst.diseaseId,
              id: row.id,
              name: row.name,
              schemeType: row.schemeType,
              doctorSchemeId: row.doctorSchemeId,
              doctorTeamId: row.doctorTeamId,
              experiencePack: row.experiencePack
            }
          ];
          this.tableDataDoctor[index].flag = false;
          this.teamServices = objService;
          this.phoneList[this.index].teamServices = this.teamServices;
          this.$message.success("服务添加成功");
          this.showAddQuestion = false;
        }
      }
      //弹窗的医生服务选用
      // this.initializationFun();
      // this.interestName = row.name;
      // this.formStepSecond.rightService = row.name;
      // this.formStepSecond.rightServiceId = row.id;
      // this.formStepSecond.rightService = row.id;
      // this.phoneList[this.index].teamServiceId = row.id;
      // this.phoneList[this.index].teamServiceName = row.name;
      // let objService = {
      //   diseaseId: this.formStepFirst.diseaseId,
      //   id: row.id,
      //   name: row.name,
      //   schemeType: row.schemeType
      // };
      // this.rightServiceObjDoctor = {
      // this.rightServiceObj = {
      //   //用来切换归属和应用范围清空之后再赋值
      //   rightService: row.name, //服务权益
      //   rightServiceId: row.id, //服务权益id
      //   interestName: row.name //服务权益名称
      // };
      // this.tableDataDoctor[index].flag = false;
      // this.teamServiceNameList.push(objService);
      // this.phoneList[this.index].teamServiceList.push(objService);
      // this.$message.success("服务添加成功");
      // if (this.teamServiceNameList.length > 0) {
      //   this.formStepSecond.rightService = row.name;
      // }
      // this.showAddQuestion = false;
    },
    assessmentSendShop(index, row) {
      this.tableDataShop[index].flag = false;
      //选择商品
      let objService = {
        goodsState: row.goodsState, //商品状态
        goodsId: 1, //商品编号
        goodsPicUrl: 1, //商品图片
        count: 1, //商品数量
        goodsName: row.goodsName, //商品名称
        specCurrentPrice: "", //规格零售价-现价
        goodsDesc: row.goodsDesc //商品说明
      };
      shopDetail({
        goodId: row.goodsId
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            objService = {
              goodsState: row.goodsState, //商品状态
              goodsId: res.data.goodsId, //商品编号
              goodsPicUrls: res.data.goodsPicUrl
                ? res.data.goodsPicUrl.split(",")
                : [],
              goodsPicUrl: res.data.goodsPicUrl, //商品图片
              count: 1, //商品数量
              goodsName: res.data.goodsName, //商品名称
              specCurrentPrice: res.data.goodsSpecList[0].specCurrentPrice, //规格零售价-现价
              goodsDesc: res.data.goodsDesc //商品说明
            };
            this.tableDataShop[index].flag = false;
            this.shopNameList.push(objService);
          }
        }
      });
      this.phoneList[this.index].goods = this.shopNameList;
      // let objService = {
      //   goodsState: row.goodsState, //商品状态
      //   goodsld: 1, //商品编号
      //   goodsPicUrl: 1, //商品图片
      //   count: 1, //商品数量
      //   goodsName: row.goodsName, //商品名称
      //   specCurrentPrice:  row.goodsSpecVoList[0].specCurrentPrice, //规格零售价-现价
      //   goodsDesc: row.goodsDesc //商品说明
      // };

      // this.shopNameList.push(objService);
      // this.phoneList[this.index].teamServiceList.push(objService);
    },
    initializationFun() {
      //每次选择的时候都初始化为未选择
      this.tableDataDoctor = this.tableDataDoctor.map(item => {
        return {
          ...item,
          flag: true
        };
      });
      this.tableData = this.tableData.map(item => {
        return {
          ...item,
          flag: true
        };
      });
      this.tableDataShop = this.tableData.map(item => {
        return {
          ...item,
          flag: true
        };
      });
    },
    termListDataRequest() {
      termListData({}).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.diseaseList = res.data;
          } else {
            this.diseaseList = [];
          }
        }
      });
    },
    hospitalListRequest() {
      hospitalList({}).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.institutionList = res.data;
            let id = res.data[0].id;
            // this.doctorListRequest(id);
          } else {
            this.institutionList = [];
          }
        }
      });
    },
    doctorListRequest(hospitalId) {
      doctorList({ hospitalId: hospitalId }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.teamList = res.data;
          } else {
            this.teamList = [];
          }
        }
      });
    },
    getTeamServicePageRequest() {
      //服务权益的接口
      if (this.formStepSecond.buttonType == 1) {
        this.listQuery.isExperiencePack = true;
        this.listQueryDoctor.isExperiencePack = true;
      } else if (this.formStepSecond.buttonType == 4) {
        this.listQuery.isExperiencePack = null;
        this.listQueryDoctor.isExperiencePack = null;
      }
      let listQuery = {};
      if (this.switchName == "therapeuticTube") {
        //疗管服务
        listQuery = this.listQuery;
      } else {
        //医生服务
        listQuery = this.listQueryDoctor;
      }
      if (listQuery.diseaseId == "36112") {
        listQuery.diseaseId = null;
      }
      getTeamServicePage(listQuery).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (this.switchName == "therapeuticTube") {
              //疗管服务
              this.total = res.data.total;
            } else {
              //医生服务
              this.totalDoctor = res.data.total;
            }
            // if (!this.btnFlagServer) {
            //   //判断是否点击了保存按钮
            //   this.teamServiceNameList = [];
            //   this.rightServiceObj = {
            //     //用来切换归属和应用范围清空之后再赋值 归属位平台
            //     rightService: "", //服务权益
            //     rightServiceId: "", //服务权益id
            //     interestName: "", //服务权益名称
            //     schemeType: 1 //服务权益名称
            //   };
            // }
            if (res.data && res.data.records && res.data.records.length > 0) {
              // if (this.formStepSecond.buttonType == 1) {
              //   if (this.searchFlag) {
              //     //如果是搜索的，不清空
              //     this.formStepSecond.rightService = "";
              //     this.formStepSecond.rightServiceRules = "";
              //     this.rightServiceObj = {
              //       //用来切换归属和应用范围清空之后再赋值 归属位平台
              //       rightService: "", //服务权益
              //       rightServiceId: "", //服务权益id
              //       interestName: "", //服务权益名称
              //       schemeType: 1, //服务权益名称
              //       doctorSchemeId: "",
              //       doctorTeamId: "",
              //       experiencePack: ""
              //     };
              //     this.phoneList.forEach((item, index) => {
              //       if (item.type == 4) {
              //         if (item.teamServiceName || item.teamServiceId) {
              //           item.teamServiceName = "";
              //           item.teamServiceId = "";
              //           item.doctorSchemeId = "";
              //           item.doctorTeamId = "";
              //           item.experiencePack = "";
              //         }
              //         item.teamServices = [];
              //       }
              //     });
              //   }
              // } else if (this.formStepSecond.buttonType == 4) {
              //   if (this.searchFlag) {
              //     //如果是搜索的，不清空
              //     this.teamServices = [];
              //     this.phoneList.forEach((item, index) => {
              //       if (item.type == 4) {
              //         // if (item.teamServices) {
              //         //   item.teamServices = []
              //         // }
              //         item.teamServices = [];
              //       }
              //     });
              //   }
              // }
              // if (!this.detailStatus) {
              //   this.formStepSecond.rightService = "";
              //   this.formStepSecond.rightServiceId = "";
              //   this.teamServiceNameList = [];
              //   this.rightServiceObj = {
              //     //用来切换归属和应用范围清空之后再赋值 归属位平台
              //     rightService: "", //服务权益
              //     rightServiceId: "", //服务权益id
              //     interestName: "", //服务权益名称
              //     schemeType: 1 //服务权益名称
              //   };
              // }
              if (this.switchName == "therapeuticTube") {
                //疗管服务
                if (this.formStepSecond.buttonType == 1) {
                  if(this.formStepFirst.diseaseId !='36112'){
                    this.teamServiceNameList = [];
                  }else{
                    this.rightServiceObj.rightServiceId = null;
                  }

                  if (this.teamServiceNameList.length > 0) {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      this.teamServiceNameList.forEach((el, i) => {
                        if (item.id == el.id) {
                          item.flag = false;
                        }
                      });
                    });
                  } else {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      if (item.id == this.rightServiceObj.rightServiceId) {
                        item.flag = false;
                      }
                    });
                  }
                } else if (this.formStepSecond.buttonType == 4) {
                  if (this.teamServices.length > 0) {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      this.teamServices.forEach((el, i) => {
                        if (item.id == el.id) {
                          item.flag = false;
                        }
                      });
                    });
                  } else {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                    });
                  }
                }
                this.tableData = res.data.records;
              } else {
                //医生服务
                if (this.formStepSecond.buttonType == 1) {
                  if(this.formStepFirst.diseaseId !='36112'){
                    this.teamServiceNameList = [];
                  }else{
                    this.rightServiceObj.rightServiceId = null;
                  }
                  if (this.teamServiceNameList.length > 0) {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      this.teamServiceNameList.forEach((el, i) => {
                        if (item.id == el.id) {
                          item.flag = false;
                        }
                      });
                    });
                  } else {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      if (item.id == this.rightServiceObj.rightServiceId) {
                        item.flag = false;
                      }
                    });
                  }
                } else if (this.formStepSecond.buttonType == 4) {
                  if (this.teamServices.length > 0) {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                      this.teamServices.forEach((el, i) => {
                        if (item.id == el.id) {
                          item.flag = false;
                        }
                      });
                    });
                  } else {
                    res.data.records.forEach((item, index) => {
                      item.flag = true;
                    });
                  }
                }
                this.tableDataDoctor = res.data.records;
              }
              this.$forceUpdate();
            } else {
              // if (this.promptError) {
              if (this.step == "first" && this.formStepFirst.scope != 2) {
                if (this.formStepFirst.belong == 0) {
                  this.$message.error("当前没有公共领取的疗管链，请检查");
                }
              }
              if (this.switchName == "therapeuticTube") {
                //疗管服务
                this.tableData = [];
              } else {
                //医生服务
                this.tableDataDoctor = [];
              }
            }
          } else {
            if (this.switchName == "therapeuticTube") {
              //疗管服务
              this.tableData = [];
            } else {
              //医生服务
              this.tableDataDoctor = [];
            }
            this.$forceUpdate();
            // if (this.promptError) {
            if (this.step == "first" && this.formStepFirst.scope != 2) {
              if (this.formStepFirst.belong == 0) {
                //平台
                this.$message.error("当前没有公共领取的疗管链，请检查");
              }
            }
          }
        } else {
          this.total = 0;
          // this.formStepSecond.rightServiceRules = "";
          // this.formStepSecond.rightService = null;
          // this.formStepSecond.rightServiceRules = "";
          if (this.switchName == "therapeuticTube") {
            //疗管服务
            this.tableData = [];
          } else {
            //医生服务
            this.tableDataDoctor = [];
          }
          this.$forceUpdate();
        }
      });
    },
    clearData() {},
    categoryListRequest() {
      //请求按钮颜色
      let btncolor = [];
      let btnFontcolor = [];
      categoryList({ code: "landing_page_button_preference" }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            res.data.forEach((item, index) => {
              if (item.code == "landing_page_button_color") {
                this.btnColorId = item.code;
                this.btndescription = item.description;

                if (item.description) {
                  btncolor = item.description && item.description.split(",");
                }
                let arr1 =
                  btncolor.length &&
                  btncolor.map((item, index) => {
                    return {
                      value: index,
                      colorText: item
                    };
                  });
                let arrBtnColor = arr1.slice(-5);
                this.btnColorList = this.btnColorList.concat(arrBtnColor);
                this.btnColorList.map((item, index) => {
                  return {
                    ...item,
                    value: index + 1
                  };
                });
              }
              if (item.code == "landing_page_button_font_color") {
                this.btnFontcolorId = item.code;
                this.btnFontdescription = item.description;
                if (item.description) {
                  btnFontcolor =
                    item.description && item.description.split(",");
                }

                let arr2 =
                  btnFontcolor.length &&
                  btnFontcolor.map((item, index) => {
                    return {
                      value: index,
                      colorText: item
                    };
                  });
                let arrTextColor = arr2.slice(-5);
                this.textColorList = this.textColorList.concat(arrTextColor);
                this.textColorList.map((item, index) => {
                  return {
                    ...item,
                    value: index + 1
                  };
                });
              }
            });
          } else {
            // this.institutionList = [];
          }
        }
      });
    },
    pagelandDetailRequest() {
      //请求详情
      this.phoneList = [];
      this.formStepSecond.freeForm = [];
      this.formStepSecond.contentConfigImageUrl = [];
      this.formStepSecond.videoList = [];
      this.rightServiceObj = {
        //用来切换归属和应用范围清空之后再赋值
        rightService: "", //服务权益
        rightServiceId: "", //服务权益id
        interestName: "", //服务权益名称
        schemeType: "", //标识 判断当前按钮绑定的是医生服务还是 疗管服务
        doctorSchemeId: "",
        doctorTeamId: "",
        experiencePack: ""
      };
      this.teamServiceNameList = [];
      this.teamServices = [];
      this.shopNameList = [];
      pagelandDetail({ id: this.id }).then(res => {
        if (res.code == 0) {
          this.formStepSecond.backgroundImageUrl = res.data.backgroundImageUrl;

          this.formStepFirst.name = res.data.name;
          this.title = res.data.title;
          this.formStepFirst.title = res.data.title;
          this.formStepFirst.belong =
            res.data.belong && res.data.belong.toString();
          this.formStepFirst.hospitalId =
            res.data.hospitalId && res.data.hospitalId.toString();
          this.formStepFirst.realNameCert = res.data.realNameCert

          this.phoneList = res.data.content;
          if (res.data.hospitalId && res.data.doctorTeamId) {
            this.doctorListRequest(res.data.hospitalId);
          }
          if (res.data.doctorTeamId) {
            this.formStepFirst.doctorTeamId =
              res.data.doctorTeamId && res.data.doctorTeamId.toString();
            this.getDiseaseIdListByIdRequest1(res.data.doctorTeamId).then(
              item => {
                if (item) {
                  
                  this.diseaseNameChangeId =
                    res.data.diseaseId && res.data.diseaseId.toString();
                  this.oldDiseaseId = res.data.diseaseId && res.data.diseaseId.toString();
                  this.listQuery.diseaseId =
                    res.data.diseaseId && res.data.diseaseId.toString();
                  this.listQueryDoctor.diseaseId =
                    res.data.diseaseId && res.data.diseaseId.toString();
                  let arr = this.diseaseList.filter(item => {
                    return item.id == res.data.diseaseId;
                  });
                  let diseaseIndex = this.listUsedDiseaseTypeList.findIndex(
                    item => {
                      return item == res.data.diseaseId;
                    }
                  );                  
                  this.formStepFirst.scope = res.data.scope * 1;
                  this.diseaseDiagnosisNew(arr, res.data.diseaseId);

                  let diseaseIdList = this.diseaseListBlone.filter(item => {
                    return item.id == res.data.diseaseId;
                  });
                  if (diseaseIdList.length == 0) {
                    this.formStepFirst.diseaseId = null;
                  } else {
                    this.formStepFirst.diseaseId =
                      res.data.diseaseId && res.data.diseaseId.toString();
                  }
                }
              }
            );
          } else {
            if (res.data.diseaseId) {
              
              this.formStepFirst.diseaseId = res.data.diseaseId.toString();

              this.diseaseNameChangeId = res.data.diseaseId.toString();
              this.oldDiseaseId = res.data.diseaseId.toString();
              this.listQuery.diseaseId = res.data.diseaseId.toString();
              let arr = this.diseaseList.filter(item => {
                return item.id == res.data.diseaseId;
              });
              let diseaseIndex = this.listUsedDiseaseTypeList.findIndex(
                item => {
                  return item == res.data.diseaseId;
                }
              );
              this.formStepFirst.scope = res.data.scope;
              this.diseaseDiagnosisNew(arr, res.data.diseaseId);
              
              if (arr.length == 0) {
                this.formStepFirst.diseaseId = null;
              } else {
                this.formStepFirst.diseaseId =
                  res.data.diseaseId && res.data.diseaseId.toString();
              }
            }
          }
          let arr = this.diseaseList.filter(item => {
            return item.id == this.formStepFirst.diseaseId;
          });
          if (arr.length > 0) {
            this.suborderCode = arr[0].suborderCode;
          }

          if (res.data.diseaseId == "36112") {
            this.scope1 = true;
            this.scope2 = true;
            this.formStepFirst.scope = 2;
            this.suborderCode = 0;
          }

          this.formStepFirst.shareDesc = res.data.shareDesc;
          this.formStepFirst.shareImageUrl = res.data.shareImageUrl;

          //
          // this.phoneList[this.index].
          // this.phoneList = res.data.content;
          if (res.data.shareImageUrl) {
            this.phoneList.unshift();
          }
          res.data.content.forEach((item, index) => {
            if (item.type == 1) {
              this.formStepSecond.contentConfigImageUrl.push(item.url);
            }
            if (item.type == 2) {
              this.formStepSecond.videoList.push(item.url);
            }
            if (item.type == 5) {
              // this.formStepSecond.isRequireUpload = item.isRequireUpload?'1':'0';
              this.formStepSecond.leastNum = item.leastNum;
              this.formStepSecond.isAddRequire = "1";
              item.isAddRequire = "1";
              this.formStepSecond.imgText = `请上传至少 ${item.leastNum} 张图片`;
              if (item.isGenerateInterpretationTask) {
                //是否生成运营解读任务
                this.formStepSecond.isGenerateInterpretationTask =
                  item.isGenerateInterpretationTask;
              } else {
                this.formStepSecond.isGenerateInterpretationTask = false;
              }
            }
            if (item.type == 4 && item.buttonType == 1) {
              // this.rightServiceObj = {
              //   //用来切换归属和应用范围清空之后再赋值
              //   rightService: item.teamServiceName, //服务权益
              //   rightServiceId: item.teamServiceId, //服务权益id
              //   interestName: item.teamServiceName, //服务权益名称
              //   schemeType: item.schemeType //标识 判断当前按钮绑定的是医生服务还是 疗管服务
              // };
              // this.rightServiceObjDoctor = {
              //   //用来切换归属和应用范围清空之后再赋值
              //   rightService: item.teamServiceName, //服务权益
              //   rightServiceId: item.teamServiceId, //服务权益id
              //   interestName: item.teamServiceName, //服务权益名称
              //   schemeType: item.schemeType //标识 判断当前按钮绑定的是医生服务还是 疗管服务
              // };
            }
          });
          let arrayFrom = [];
          this.phoneList.forEach((item, indedx) => {
            if (item.formType == 1) {
              item.flag = 1;
              if (!item.bind) {
                let obj1 = {
                  diseaseName: "身份信息",
                  diseaseId: "1"
                };
                this.formStepSecond.freeForm.push(obj1);
              } else {
                let obj1 = {
                  diseaseName: "身份信息",
                  diseaseId: "1"
                };
                arrayFrom.push(obj1);
              }
            }
            if (item.formType == 2) {
              item.flag = 2;
              if (!item.bind) {
                let obj2 = {
                  diseaseName: "病种阶段",
                  diseaseId: "2"
                };
                this.formStepSecond.freeForm.push(obj2);
              } else {
                let obj2 = {
                  diseaseName: "病种阶段",
                  diseaseId: "2"
                };
                arrayFrom.push(obj2);
              }
            }
            if (item.formType == 3) {
              item.flag = 3;
              if (!item.bind) {
                let obj3 = {
                  diseaseName: "BMI",
                  diseaseId: "3"
                };
                this.formStepSecond.freeForm.push(obj3);
              } else {
                let obj3 = {
                  diseaseName: "BMI",
                  diseaseId: "3"
                };
                arrayFrom.push(obj3);
              }
            }
            if (item.bindForm && item.bindForm != "") {
              this.formStepSecond.buttonNum = 1;
              item.evocativeForm = 1;
            } else {
              item.evocativeForm = 2;
            }

            if (item.type == 3 && item.bind) {
              item.flag = 0;
            }
            if (item.type == 4) {
              item.teamServiceList ? item.teamServiceList : [];

              if (item.teamServiceList && item.teamServiceList.length > 0) {
                this.teamServiceNameList = item.teamServiceList;
              }
              if (item.teamServiceId) {
                this.rightServiceObj = {
                  //用来切换归属和应用范围清空之后再赋值
                  rightService: item.teamServiceName, //服务权益
                  rightServiceId: item.teamServiceId, //服务权益id
                  interestName: item.teamServiceName, //服务权益名称
                  schemeType: item.schemeType, //标识 判断当前按钮绑定的是医生服务还是 疗管服务
                  doctorSchemeId: item.doctorSchemeId,
                  doctorTeamId: item.doctorTeamId,
                  experiencePack: item.experiencePack
                };
                this.rightServiceObjDoctor = {
                  //用来切换归属和应用范围清空之后再赋值
                  rightService: item.teamServiceName, //服务权益
                  rightServiceId: item.teamServiceId, //服务权益id
                  interestName: item.teamServiceName, //服务权益名称
                  schemeType: item.schemeType, //标识 判断当前按钮绑定的是医生服务还是 疗管服务
                  doctorSchemeId: item.doctorSchemeId,
                  doctorTeamId: item.doctorTeamId,
                  experiencePack: item.experiencePack
                };
              }
              // item.goods = [
              //   {
              //     goodsState: 1, //商品状态
              //     goodsld: 1, //商品编号
              //     goodsPicUrl: 1, //商品图片
              //     count: 1, //商品数量
              //     goodsName: "商品名称商品名称", //商品名称
              //     specCurrentPrice: 1, //规格零售价-现价
              //     goodsDesc: "商品说明商品说明商品说明商品说明" //商品说明
              //   }
              // ];
              // this.shopNameList = item.goods;
              // teamServices

              this.formStepSecond.rightServiceRules = item.teamServiceName;
              // item.teamServiceList = [];
            }
          });
          let newArr = this.formMessageListAll.filter(v =>
            arrayFrom.every(val => val.diseaseId != v.diseaseId)
          );
          this.formMessageList1 = newArr;
          this.screenFrom();
          this.$forceUpdate();
        }
      });
    },
    screenFrom() {
      //筛选表单
      let arrayFrom = [];
      let arrayFromFree = [];
      this.phoneList.forEach((item, indedx) => {
        if (item.formType == 1) {
          if (item.bind) {
            if (item.whetherBindFrom != 0) {
              let obj1 = {
                diseaseName: "身份信息",
                diseaseId: "1"
              };
              arrayFrom.push(obj1);
            }
          } else {
            if (item.whetherBindFrom != 0) {
              let obj1 = {
                diseaseName: "身份信息",
                diseaseId: "1"
              };
              arrayFromFree.push(obj1);
            }
          }
        }
        if (item.formType == 2) {
          if (item.bind) {
            if (item.whetherBindFrom != 0) {
              let obj2 = {
                diseaseName: "病种阶段",
                diseaseId: "2"
              };
              arrayFrom.push(obj2);
            }
          } else {
            if (item.whetherBindFrom != 0) {
              let obj2 = {
                diseaseName: "病种阶段",
                diseaseId: "2"
              };
              arrayFromFree.push(obj2);
            }
          }
        }
        if (item.formType == 3) {
          if (item.bind) {
            if (item.whetherBindFrom != 0) {
              let obj3 = {
                diseaseName: "BMI",
                diseaseId: "3"
              };
              arrayFrom.push(obj3);
            }
          } else {
            if (item.whetherBindFrom != 0) {
              let obj3 = {
                diseaseName: "BMI",
                diseaseId: "3"
              };
              arrayFromFree.push(obj3);
            }
          }
        }
      });
      let newArr = this.formMessageListAll.filter(v =>
        arrayFrom.every(val => val.diseaseId != v.diseaseId)
      );
      let newArrFree = this.formMessageListAll.filter(v =>
        arrayFromFree.every(val => val.diseaseId != v.diseaseId)
      );
      this.formMessageList1 = newArr;
      this.formMessageList2 = newArrFree;
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.listQuery.current = 1;
      this.getTeamServicePageRequest();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getTeamServicePageRequest();
    },
    handleSizeChangeDoctor(val) {
      this.listQueryDoctor.size = val;
      this.listQueryDoctor.current = 1;
      this.getTeamServicePageRequest();
    },
    handleCurrentChangeDoctor(val) {
      this.listQueryDoctor.current = val;
      this.getTeamServicePageRequest();
    },
    handleSizeChangeShop(val) {
      this.listQueryShop.size = val;
      this.listQueryShop.current = 1;
      this.shopPageRequest();
    },
    handleCurrentChangeShop(val) {
      this.listQueryShop.current = val;
      this.shopPageRequest();
    },
    deleteClick(item, index) {
      //删除
      this.$confirm("确认删除嘛？")
        .then(_ => {
          if (item.type == 1) {
            //图片
            let index1 = this.formStepSecond.contentConfigImageUrl.findIndex(
              v => v == item.url
            );
            this.formStepSecond.contentConfigImageUrl.splice(index1, 1);
            this.phoneList.splice(index, 1);
          }
          if (item.type == 2) {
            //视频
            let index2 = this.formStepSecond.videoList.findIndex(
              v => v == item.url
            );
            this.formStepSecond.videoList.splice(index2, 1);
            this.phoneList.splice(index, 1);
          }
          if (item.type == 3) {
            //表单
            if (item.bind) {
              //按钮表单
              let index3 = this.formStepSecond.buttonBindForm.findIndex(
                v => v.diseaseId == item.formType
              );
              if (index3 >= 0) {
                this.formStepSecond.buttonBindForm.splice(index3, 1);
              }

              this.formBtnFlag = true;
              let arrForm = this.phoneList.filter(item => {
                return item.type == 4;
              });
              let id = null;
              arrForm.forEach((item, indx) => {
                if (item.bindForm) {
                  if (item.bindForm.indexOf(this.phoneList[index].id) != -1) {
                    id = item.id;
                  }
                }
              });
              if (id) {
                let indexBtn = this.phoneList.findIndex(item => {
                  return item.id == id;
                });
                let arr1 = this.phoneList[indexBtn].bindForm.split(",");
                let arr2 = arr1.filter(item => {
                  return item != this.phoneList[index].id;
                });
                this.phoneList[indexBtn].bindForm = arr2.toString();
              }
            } else {
              //游离表单
              let indexfree = this.formStepSecond.freeForm.findIndex(
                v => v.diseaseId == item.formType
              );
              if (indexfree >= 0) {
                this.formStepSecond.freeForm.splice(indexfree, 1);
              }

              this.formButtonTypeList = this.formStepSecond.freeForm;
            }
            this.phoneList.splice(index, 1);
          }
          if (item.type == 4) {
            //按钮
            if (item.buttonType == 4) {
              this.teamServices = [];
              this.rightServiceObj = {
                //用来切换归属和应用范围清空之后再赋值
                rightService: "", //服务权益
                rightServiceId: "", //服务权益id
                interestName: "", //服务权益名称
                schemeType: "", //标识 判断当前按钮绑定的是医生服务还是 疗管服务
                doctorSchemeId: "",
                doctorTeamId: "",
                experiencePack: ""
              };
            }
            let isButtonHover = item.isButtonHover;
            this.btnFlag = false;
            this.formButtonTypeList = this.formStepSecond.freeForm;
            this.formStepSecond.buttonBindForm = [];
            let showArr = item.bindForm && item.bindForm.split(",");
            if (showArr) {
              this.phoneList.forEach(element => {
                if (showArr.indexOf(element.id) > -1) {
                  element.flag = 0;
                  element.whetherBindFrom = 0;
                }
              });
            }
            if (item.buttonType == 1) {
              this.formStepSecond.rightService = "";
              this.formStepSecond.rightServiceRules = "";
              this.rightServiceObj = {
                //用来切换归属和应用范围清空之后再赋值 归属位平台
                rightService: "", //服务权益
                rightServiceId: "", //服务权益id
                interestName: "", //服务权益名称
                schemeType: 1 //服务权益名称
              };
              this.teamServiceNameList = [];
            }
            this.phoneList.splice(index, 1);
            if (isButtonHover) {
              this.resetBtnFun();
            }
          }
          // this.resetBtnFun();
          this.choseBtnIndex = this.phoneList.findIndex(item => {
            return item.id == this.selectBtnArea.id;
          });
          this.screenFrom();
        })
        .catch(_ => {});
    },
    resetBtnFun() {
      //重新排列按钮悬停
      this.phoneList.forEach((item, index) => {
        if (item.type == 4) {
          if (item.isButtonHover) {
            item.buttonHoverSort = 1;
          } else {
            item.buttonHoverSort = 0;
          }
        }
      });
    },
    therapistByDiseaseIdRequest() {
      therapistByDiseaseId({ diseaseId: this.diseaseNameChangeId }).then(
        res => {
          if (res.code == 0) {
            if (res.data) {
              if (this.formStepFirst.scope != 1) {
                if (this.formStepSecond.buttonType == 1) {
                  this.rightServiceObj = {
                    //用来切换归属和应用范围清空之后再赋值
                    rightService: res.data.name, //服务权益
                    rightServiceId: res.data.id, //服务权益id
                    interestName: res.data.name //服务权益名称
                  };
                  this.diseaseNameService = res.data.name;
                  this.formStepSecond.rightService = res.data.name;
                  this.formStepSecond.rightServiceRules = res.data.name;
                  if (
                    this.phoneList[this.index] &&
                    this.phoneList[this.index].teamServiceId &&
                    this.phoneList[this.index].teamServiceName
                  ) {
                    this.phoneList[this.index].teamServiceId = res.data.id;
                    this.phoneList[this.index].teamServiceName = res.data.name;
                  }
                } else if (this.formStepSecond.buttonType == 4) {
                  let serviceObj = [
                    {
                      //用来切换归属和应用范围清空之后再赋值
                      rightService: res.data.name, //服务权益
                      rightServiceId: res.data.id, //服务权益id
                      interestName: res.data.name, //服务权益名称
                      diseaseId: res.data.diseaseTypeId,
                      id: res.data.id,
                      name: res.data.name,
                      schemeType: res.data.schemeType,
                      doctorSchemeId: res.data.doctorSchemeId,
                      doctorTeamId: res.data.doctorTeamId,
                      experiencePack: res.data.experiencePack
                    }
                  ];

                  // this.teamServices.push(serviceObj);
                  this.teamServices = serviceObj;
                  this.phoneList[this.index].teamServices = this.teamServices;
                }
              } else {
                // if (!this.detailStatus) {
                //   this.diseaseNameService = "";
                //   this.formStepSecond.rightService = "";
                //   this.formStepSecond.rightServiceId = "";
                //   this.formStepSecond.rightServiceRules = "";
                //   this.phoneList.forEach((item, index) => {
                //     if (item.type == 4) {
                //       if (item.teamServiceName || item.teamServiceId) {
                //         item.teamServiceName = "";
                //         item.teamServiceId = "";
                //       }
                //     }
                //   });
                // }
              }
            } else {
              if (this.rightServiceObj.schemeType == 1) {
                if (this.formStepSecond.buttonType == 1) {
                  this.diseaseNameService = "";
                  this.formStepSecond.rightService = "";
                  this.formStepSecond.rightServiceId = "";
                  this.formStepSecond.rightServiceRules = "";
                  this.phoneList.forEach((item, index) => {
                    if (item.type == 4) {
                      if (item.teamServiceName || item.teamServiceId) {
                        item.teamServiceName = "";
                        item.teamServiceId = "";
                      }
                    }
                  });
                } else if (this.formStepSecond.buttonType == 4) {
                  this.teamServices = [];
                  this.phoneList[this.index].teamServices = [];
                }
              }
              if (this.step == "first" && this.formStepFirst.scope != 2) {
                if (this.formStepFirst.belong == 0) {
                  this.$message.error("当前没有公共领取的疗管链，请检查");
                }
              }
            }
          }
        }
      );
    },
    listUsedDiseaseTypeRequest() {
      return new Promise((resolve, reject) => {
        listUsedDiseaseType({
          id: this.id
        }).then(res => {
          if (res.code == 0) {
            if (res.data) {
              this.listUsedDiseaseTypeList = res.data;
              resolve(true);
            }
          } else {
            reject(false);
          }
        });
      });
    },
    bigVideoClick(index) {
      this.showAddQuestionvideo = true;
      this.showAddQuestionvideoUrl = "";
      this.showAddQuestionvideoUrl = this.formStepSecond.videoList[index];

      this.$forceUpdate();
    },
    deleteVideoClick(index) {
      let indexs = this.phoneList.findIndex(item => {
        return item.url == this.formStepSecond.videoList[index];
      });
      this.phoneList.splice(indexs, 1);
      this.formStepSecond.videoList.splice(index, 1);
      this.$forceUpdate();
    },
    handleCloseVideo() {
      this.showAddQuestionvideoUrl = null;
      this.showAddQuestionvideo = false;
    },
    getDiseaseIdListByIdRequest(id) {
      getDiseaseIdListById({ id: id }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.diseaseListBlone = res.data;
            if (res.data.length == 1) {
              this.formStepFirst.diseaseId = res.data[0].id;
              this.diseaseNameChangeId = res.data[0].id;
            }
          }
        }
      });
    },
    getDiseaseIdListByIdRequest1(id) {
      return new Promise((resolve, reject) => {
        getDiseaseIdListById({ id: id }).then(res => {
          if (res.code == 0) {
            if (res.data) {
              this.diseaseListBlone = res.data;
              resolve(true);
            }
          } else {
            reject(false);
          }
        });
      });
    },
    formButtonTypeFun() {
      this.formButtonTypeFlag = false;
      let arrBtn = this.phoneList.filter(item => {
        return item.type == 4;
      });
      this.formButtonTypeFlag = arrBtn.some(item => {
        return item.evocativeForm == "1";
      });
    },
    symptomsChange(e) {
      //是否添加图片
      let obj = {
        type: 5,
        isAddRequire: true,
        // isRequireUpload: true,
        leastNum: this.formStepSecond.leastNum,
        isGenerateInterpretationTask: this.formStepSecond
          .isGenerateInterpretationTask,
        sort: 4,
        id: this.idFun()
      };
      if (e == 1) {
        this.phoneList.push(obj);
      } else {
        let numIndex = this.phoneList.findIndex(item => {
          return item.type == 5;
        });
        this.phoneList.splice(numIndex, 1);
        // this.phoneList[numIndex].isAddRequire = this.formStepSecond.isAddRequire;
      }
      // let numIndex = this.phoneList.findIndex(item => {
      //   return item.type == 5;
      // });
      // this.phoneList[numIndex].isAddRequire = this.formStepSecond.isAddRequire;
    },
    pretationTaskChange(e) {
      let numIndex = this.phoneList.findIndex(item => {
        return item.type == 5;
      });
      if (e == true) {
        if (numIndex > -1) {
          this.phoneList[numIndex].isGenerateInterpretationTask = true;
        }
      } else {
        if (numIndex > -1) {
          this.phoneList[numIndex].isGenerateInterpretationTask = false;
        }
      }
    },
    imgNumInput(e) {
      //最少图片上传数量文本框事件
      this.formStepSecond.leastNum = e.replace(/[^\d]/g, "");
      if (e === "0" || e > 30) {
        this.$message.error("上传的图片张数不能大于30并且不能小于1");
      }
      this.formStepSecond.imgText = `请上传至少 ${e} 张图片`;
      let numIndex = this.phoneList.findIndex(item => {
        return item.type == 5;
      });

      if (numIndex >= 0) {
        this.phoneList[numIndex].leastNum = this.formStepSecond.leastNum;
      }
    },
    symptomsRequireChange(e) {
      //是否必传change事件
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      if (e == "1") {
        this.phoneList[this.choseBtnIndex].isRequireUpload = 1;
      } else {
        this.phoneList[this.choseBtnIndex].isRequireUpload = 0;
      }
    },
    definedGoodsCountChange(e) {
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].definedGoodsCount = e;
    },
    FeedbackRequireChange(e) {
      //是否跳转评估
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].isJumpToFeedback = e;
    },
    videoNumberChange(e) {
      //选择视频号id
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].channelId = e;
    },
    styleTypeChange(e) {
      //表单中按钮样式的change事件
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].styleType = e;
      this.assignmentFun(
        this.choseBtnIndex,
        this.phoneList[this.choseBtnIndex]
      );
      this.$refs["formStepSecond"].clearValidate("btnImageUrl");
      // this.phoneList[this.choseBtnIndex].text = e;
    },
    assignmentFun(i, obj) {
      // this.rightServiceObj = {
      //       //用来切换归属和应用范围清空之后再赋值
      //       rightService: null, //服务权益
      //       rightServiceId: null, //服务权益id
      //       interestName: null, //服务权益名称            
      //     };
      //按钮的属性赋值道表单上
      this.$refs["formStepSecond"].clearValidate("smallApp");
      this.$refs["formStepSecond"].clearValidate("btnImageUrl");
      //赋值方法
      this.formStepSecond.buttonText = obj.text; //按钮文字
      this.formStepSecond.evocativeForm = obj.evocativeForm;
      this.interestName = obj.teamServiceName;
      if (obj.teamServiceName) {
        this.detailStatus = true;
      }
      this.formStepSecond.rightService = obj.teamServiceName;
      this.formStepSecond.rightServiceRules = obj.teamServiceName;
      this.formStepSecond.rightServiceId = obj.teamServiceId;
      this.formStepSecond.colorText = obj.fontColor; //文字颜色
      this.formStepSecond.colorButton = obj.color; //按钮颜色
      this.formStepSecond.smallApp = obj.appId; //小程序
      this.formStepSecond.pageLink = obj.jumpUrl; //跳转页面链接
      this.formStepSecond.channelId = obj.channelId; //视频号ID
      this.formStepSecond.definedGoodsCount = obj.definedGoodsCount; // 商品数量自定义
      this.formStepSecond.buttonType = obj.buttonType; //按钮类型
      this.formStepSecond.isButtonHover = obj.isButtonHover
        ? obj.isButtonHover
        : false; //视频号ID
      this.formStepSecond.buttonHoverSort = obj.buttonHoverSort
        ? obj.buttonHoverSort
        : false; //视频号ID
      if (obj.isJumpToFeedback) {
        //是否跳评估反馈
        this.formStepSecond.isJumpToFeedback = obj.isJumpToFeedback;
      } else {
        this.formStepSecond.isJumpToFeedback = false;
      }

      if (obj.isRequireUpload == undefined || obj.isRequireUpload == null) {
        this.formStepSecond.isRequireUpload = "1"; //是否必传
      } else if (obj.isRequireUpload == true) {
        this.formStepSecond.isRequireUpload = "1"; //是否必传
      } else {
        this.formStepSecond.isRequireUpload = "0"; //是否必传
      }
      this.detailStatus = true;
      if (
        this.formStepSecond.buttonType == 1 ||
        this.formStepSecond.buttonType == 4
      ) {
        if (obj.teamServiceList && obj.teamServiceList.length > 0) {
          this.detailStatus = true;
          this.teamServiceNameList = obj.teamServiceList;
          // if (this.formStepFirst.scope == 2 && this.suborderCode == 0) {
          if (this.formStepFirst.scope == 2) {
            this.formStepSecond.rightService = obj.teamServiceList[0].name;
            this.formStepSecond.rightServiceRules = obj.teamServiceList[0].name;
          } else {
            this.formStepSecond.rightService = "";
            this.formStepSecond.rightServiceRules = "";
          }
        } else {
          this.teamServiceNameList = [];
        }
        if (obj.goods && obj.goods.length > 0) {
          this.shopNameList = obj.goods;
        } else {
          this.shopNameList = [];
        }

        if (obj.teamServices && obj.teamServices.length > 0) {
          this.teamServices = obj.teamServices;
          this.rightServiceObj = {
            //用来切换归属和应用范围清空之后再赋值
            rightService: obj.teamServices[0].name, //服务权益
            rightServiceId: obj.teamServices[0].id, //服务权益id
            interestName: obj.teamServices[0].name, //服务权益名称
            schemeType: obj.teamServices[0].schemeType,
            doctorSchemeId: obj.teamServices[0].doctorSchemeId,
            doctorTeamId: obj.teamServices[0].doctorTeamId,
            experiencePack: obj.teamServices[0].experiencePack
          };
          if (obj.teamServices[0].schemeType == 1) {
            //疗管服务
            this.switchName = "therapeuticTube";
            this.listQuery.isTherapistService = true;
          } else {
            //医生服务
            this.switchName = "doctor";
          }
        } else {
          this.teamServices = [];
        }
        
        if(obj.teamServiceId && obj.teamServiceName){
          this.rightServiceObj = {
            //用来切换归属和应用范围清空之后再赋值
            rightService: obj.teamServiceName, //服务权益
            rightServiceId: obj.teamServiceId, //服务权益id
            interestName: obj.teamServiceName, //服务权益名称            
          };
        }
      }
      // this.formStepSecond.leastNum = obj.leastNum; //上传的数量
      this.formStepSecond.btnImageUrl = obj.url ? obj.url : ""; //按钮图片
      this.formStepSecond.styleType = obj.styleType ? obj.styleType : 1;
      let indextextColor = this.textColorList.findIndex(item => {
        return item.colorText == obj.fontColor;
      });
      this.textColorIndex = indextextColor;
      let indexbtnColor = this.btnColorList.findIndex(item => {
        return item.colorText == obj.color;
      });
      this.btnColorIndex = indexbtnColor;
      if (obj.bindForm && obj.bindForm != "") {
        obj.arrForm = obj.bindForm.split(",");
        this.formStepSecond.buttonBindForm = [];
        this.formArrList = this.FilterData(this.phoneList, obj.arrForm);
        for (let i = 0; i < this.formArrList.length; i++) {
          if (this.formArrList[i].formType == 1) {
            let obj1 = {
              diseaseName: "身份信息",
              diseaseId: "1"
            };
            this.formStepSecond.buttonBindForm.push(obj1);
          }
          if (this.formArrList[i].formType == 2) {
            let obj2 = {
              diseaseName: "病种阶段",
              diseaseId: "2"
            };
            this.formStepSecond.buttonBindForm.push(obj2);
          }
          if (this.formArrList[i].formType == 3) {
            let obj3 = {
              diseaseName: "BMI",
              diseaseId: "3"
            };
            this.formStepSecond.buttonBindForm.push(obj3);
          }
        }
        this.formStepSecond.evocativeForm = 1;
        obj.evocativeForm = 1;
      } else {
        this.formStepSecond.evocativeForm = 2;
        obj.evocativeForm = 2;
      }
    },
    serviceClick(item) {
      //弹窗切换疗管服务 医生服务
      this.switchName = item;
      if (item == "therapeuticTube") {
        this.listQuery.size = 10;
        this.listQuery.current = 1;
        this.getTeamServicePageRequest();
      } else if (item == "doctor") {
        this.listQueryDoctor.size = 10;
        this.listQueryDoctor.current = 1;
        this.getTeamServicePageRequest();
      }
    },
    resetClick() {
      //弹窗疗管服务重置
      this.listQuery.size = 10;
      this.listQuery.current = 1;
      this.listQuery.keyword = null;
      this.searchFlag = false;
      this.getTeamServicePageRequest();
    },
    searchClick() {
      //弹窗疗管服务搜索
      this.listQuery.size = 10;
      this.listQuery.current = 1;
      this.searchFlag = false;
      this.getTeamServicePageRequest();
    },
    resetClickDoctor() {
      //弹窗疗管服务重置
      this.listQueryDoctor.size = 10;
      this.listQueryDoctor.current = 1;
      this.listQueryDoctor.keyword = null;
      this.searchFlag = false;
      this.getTeamServicePageRequest();
    },
    searchClickDoctor() {
      //弹窗疗管服务搜索
      this.listQueryDoctor.size = 10;
      this.listQueryDoctor.current = 1;
      this.searchFlag = false;
      this.getTeamServicePageRequest();
    },
    resetClickShop() {
      //弹窗商品服务重置
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.listQueryShop.goodsName = null;
      this.shopPageRequest();
    },
    searchClickShop() {
      //弹窗商品服务搜索
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.shopPageRequest();
    },
    tagHandleClose(index) {
      //删除选中的服务权益
      this.teamServiceNameList.splice(index, 1);
      if (this.teamServiceNameList.length <= 0) {
        this.formStepSecond.rightService = null;
        this.formStepSecond.rightServiceRules = "";
      }
      this.tableData.forEach((item, index) => {
        item.flag = false;
        this.teamServiceNameList.forEach((el, i) => {
          if (item.id == el.id) {
            item.flag = true;
          }
        });
      });
      this.tableDataDoctor.forEach((item, index) => {
        item.flag = false;
        this.teamServiceNameList.forEach((el, i) => {
          if (item.id == el.id) {
            item.flag = true;
          }
        });
      });
    },
    tagHandleCloseService(index) {
      //删除选中的服务权益
      this.teamServices.splice(index, 1);
      this.choseBtnIndex = this.phoneList.findIndex(item => {
        return item.id == this.selectBtnArea.id;
      });
      this.phoneList[this.choseBtnIndex].teamServices = this.teamServices;

      this.tableData.forEach((item, index) => {
        item.flag = false;
        this.teamServices.forEach((el, i) => {
          if (item.id == el.id) {
            item.flag = true;
          }
        });
      });
      this.tableDataDoctor.forEach((item, index) => {
        item.flag = false;
        this.teamServices.forEach((el, i) => {
          if (item.id == el.id) {
            item.flag = true;
          }
        });
      });
    },
    tagHandleCloseShop(index) {
      //删除选中的商品
      this.shopNameList.splice(index, 1);
      this.tableData.forEach((item, index) => {
        item.flag = false;
        this.shopNameList.forEach((el, i) => {
          if (item.goodsId == el.goodsId) {
            item.flag = true;
          }
        });
      });
    },
    reductionClick(index, eli, num) {
      //减的事件
      return;
      if (this.formStepSecond.definedGoodsCount) {
        if (this.phoneList[index].goods[eli].count <= 0) {
          return false;
        }
        this.phoneList[index].goods[eli].count--;
      }

      this.$forceUpdate();
    },
    addClick(index, eli, num) {
      //加的事件
      return;
      if (this.formStepSecond.definedGoodsCount) {
        if (this.phoneList[index].goods[eli].count >= 99) {
          return false;
        }
        this.phoneList[index].goods[eli].count++;
      }

      this.$forceUpdate();
    },
    deleteClickShop(index, eli, num) {
      // 删除商品
      this.$confirm("确认删除嘛？")
        .then(_ => {
          // return false;
          this.phoneList[index].goods.splice(eli, 1);
          // this.shopNameList.splice(eli, 1);
          this.$forceUpdate();
        })
        .catch(_ => {});
    },
    shopPageRequest() {
      shopPage(this.listQueryShop).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.records && res.data.records.length > 0) {
            //医生服务
            if (this.shopNameList.length > 0) {
              res.data.records.forEach((item, index) => {
                item.flag = true;
                this.shopNameList.forEach((el, i) => {
                  if (item.goodsId == el.goodsId) {
                    item.flag = false;
                  }
                });
              });
            } else {
              res.data.records.forEach((item, index) => {
                item.flag = true;
              });
            }
            this.tableDataShop = res.data.records;
          } else {
            this.tableDataShop = [];
          }
          this.totalShop = res.data.total;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "./landPage.less";
.list-padding {
  padding-bottom: 112px !important;
}
</style>
